export default [
    {
        "error_id": "INF-01",
        "data": [
            {
                "cross_section": "34005",
                "up_cross_section": "34014",
                "down_cross_section": "33981",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_thalweg": [
                    4998.6,
                    741.31
                ],
                "down_thalweg": [
                    4997.5,
                    741.08
                ],
                "up_bank_left": 4979.2,
                "up_bank_left_elev": 748.54,
                "up_bank_right": 5022.5,
                "up_bank_right_elev": 750.11,
                "down_bank_left": 4986.3,
                "down_bank_left_elev": 748.36,
                "down_bank_right": 5020,
                "down_bank_right_elev": 748.95,
                "up_dist": "3.00",
                "bridge_us_width": 12,
                "dist_to_xs": 3,
                "up_left_opening_station": 4987.6,
                "up_right_opening_station": null,
                "down_left_opening_station": 4987.6,
                "down_right_opening_station": null,
                "up_left_low_chord_elev": 747.71,
                "up_right_low_chord_elev": null,
                "down_left_low_chord_elev": 747.71,
                "down_right_low_chord_elev": null,
                "up_degress": [
                    {
                        "degree": -9.668668661083178,
                        "station": 4634.6,
                        "low_chord": 721.31,
                        "high_chord": 766.26
                    },
                    {
                        "degree": -4.803153744353504,
                        "station": 4649,
                        "low_chord": 721.31,
                        "high_chord": 765.05
                    },
                    {
                        "degree": -9.727578551404445,
                        "station": 4649.7,
                        "low_chord": 721.31,
                        "high_chord": 764.93
                    },
                    {
                        "degree": -7.477330306656398,
                        "station": 4651.3,
                        "low_chord": 721.31,
                        "high_chord": 764.72
                    },
                    {
                        "degree": -8.571366353941215,
                        "station": 4665.1,
                        "low_chord": 721.31,
                        "high_chord": 762.64
                    },
                    {
                        "degree": -6.852469770553889,
                        "station": 4688.4,
                        "low_chord": 721.31,
                        "high_chord": 759.84
                    },
                    {
                        "degree": -9.419101864566146,
                        "station": 4701.3,
                        "low_chord": 721.31,
                        "high_chord": 757.7
                    },
                    {
                        "degree": -4.289153328835212,
                        "station": 4701.7,
                        "low_chord": 721.31,
                        "high_chord": 757.67
                    },
                    {
                        "degree": -6.60483549674952,
                        "station": 4703.6,
                        "low_chord": 721.31,
                        "high_chord": 757.45
                    },
                    {
                        "degree": -6.914867720082606,
                        "station": 4708.3,
                        "low_chord": 721.31,
                        "high_chord": 756.88
                    },
                    {
                        "degree": -7.975620399073475,
                        "station": 4727,
                        "low_chord": 721.31,
                        "high_chord": 754.26
                    },
                    {
                        "degree": -5.428381094220301,
                        "station": 4763.2,
                        "low_chord": 721.31,
                        "high_chord": 750.82
                    },
                    {
                        "degree": -7.5195703251904,
                        "station": 4765.7,
                        "low_chord": 721.31,
                        "high_chord": 750.49
                    },
                    {
                        "degree": -2.4434668001538236,
                        "station": 4788.9,
                        "low_chord": 721.31,
                        "high_chord": 749.5
                    },
                    {
                        "degree": -1.367997412225933,
                        "station": 4795.6,
                        "low_chord": 721.31,
                        "high_chord": 749.34
                    },
                    {
                        "degree": -0.2407371527221385,
                        "station": 4807.5,
                        "low_chord": 721.31,
                        "high_chord": 749.29
                    },
                    {
                        "degree": 3.2992816989925657,
                        "station": 4816,
                        "low_chord": 721.31,
                        "high_chord": 749.78
                    },
                    {
                        "degree": 8.709516422005624,
                        "station": 4820.7,
                        "low_chord": 721.31,
                        "high_chord": 750.5
                    },
                    {
                        "degree": -5.194428907736408,
                        "station": 4822.9,
                        "low_chord": 721.31,
                        "high_chord": 750.3
                    },
                    {
                        "degree": -9.67335543240232,
                        "station": 4827.3,
                        "low_chord": 721.31,
                        "high_chord": 749.55
                    },
                    {
                        "degree": -2.5774355757558816,
                        "station": 4860.4,
                        "low_chord": 721.31,
                        "high_chord": 748.06
                    },
                    {
                        "degree": 0.7761268781677042,
                        "station": 4901,
                        "low_chord": 721.31,
                        "high_chord": 748.61
                    },
                    {
                        "degree": 2.8689744869594445,
                        "station": 4944.5,
                        "low_chord": 721.31,
                        "high_chord": 750.79
                    },
                    {
                        "degree": -0.2515408305647964,
                        "station": 4985.5,
                        "low_chord": 721.31,
                        "high_chord": 750.61
                    },
                    {
                        "degree": -2.726310993906413,
                        "station": 4987.6,
                        "low_chord": 721.31,
                        "high_chord": 750.51
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 4987.6,
                        "low_chord": 747.71,
                        "high_chord": 750.51
                    },
                    {
                        "degree": 0.5555780242457545,
                        "station": 5004.1,
                        "low_chord": 747.86,
                        "high_chord": 750.67
                    },
                    {
                        "degree": 0.4714103331047444,
                        "station": 5019.9,
                        "low_chord": 748,
                        "high_chord": 750.8
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 5019.9,
                        "low_chord": 721.31,
                        "high_chord": 750.8
                    },
                    {
                        "degree": 4.208519456764294,
                        "station": 5025.2,
                        "low_chord": 721.31,
                        "high_chord": 751.19
                    },
                    {
                        "degree": -0.5035366421387346,
                        "station": 5067.3,
                        "low_chord": 721.31,
                        "high_chord": 750.82
                    },
                    {
                        "degree": 1.6325581465491952,
                        "station": 5108,
                        "low_chord": 721.31,
                        "high_chord": 751.98
                    },
                    {
                        "degree": 1.6971561896002552,
                        "station": 5151.2,
                        "low_chord": 721.31,
                        "high_chord": 753.26
                    },
                    {
                        "degree": 2.017539764476505,
                        "station": 5195.2,
                        "low_chord": 721.31,
                        "high_chord": 754.81
                    },
                    {
                        "degree": -2.968234029871626,
                        "station": 5197.9,
                        "low_chord": 721.31,
                        "high_chord": 754.67
                    },
                    {
                        "degree": 3.433630362450652,
                        "station": 5205.9,
                        "low_chord": 721.31,
                        "high_chord": 755.15
                    },
                    {
                        "degree": 0.3370301098573568,
                        "station": 5207.6,
                        "low_chord": 721.31,
                        "high_chord": 755.16
                    },
                    {
                        "degree": 8.397302586691264,
                        "station": 5213.9,
                        "low_chord": 721.31,
                        "high_chord": 756.09
                    },
                    {
                        "degree": 12.73086878980428,
                        "station": 5219.3,
                        "low_chord": 721.31,
                        "high_chord": 757.31
                    },
                    {
                        "degree": 6.214390041356122,
                        "station": 5228.3,
                        "low_chord": 721.31,
                        "high_chord": 758.29
                    },
                    {
                        "degree": 4.28915332882161,
                        "station": 5230.3,
                        "low_chord": 721.31,
                        "high_chord": 758.44
                    },
                    {
                        "degree": -3.0168513228534573,
                        "station": 5237.7,
                        "low_chord": 721.31,
                        "high_chord": 758.05
                    },
                    {
                        "degree": 0.7392593554091894,
                        "station": 5240.8,
                        "low_chord": 721.31,
                        "high_chord": 758.09
                    },
                    {
                        "degree": 12.264773727892246,
                        "station": 5254.6,
                        "low_chord": 721.31,
                        "high_chord": 761.09
                    },
                    {
                        "degree": 13.360218444768723,
                        "station": 5256.2,
                        "low_chord": 721.31,
                        "high_chord": 761.47
                    },
                    {
                        "degree": 11.309932474017636,
                        "station": 5259.6,
                        "low_chord": 721.31,
                        "high_chord": 762.15
                    },
                    {
                        "degree": 8.69550287742522,
                        "station": 5268.1,
                        "low_chord": 721.31,
                        "high_chord": 763.45
                    },
                    {
                        "degree": 7.440052910931557,
                        "station": 5285.1,
                        "low_chord": 721.31,
                        "high_chord": 765.67
                    },
                    {
                        "degree": 13.400091627732317,
                        "station": 5291.9,
                        "low_chord": 721.31,
                        "high_chord": 767.29
                    },
                    {
                        "degree": 5.237476066810002,
                        "station": 5293.1,
                        "low_chord": 721.31,
                        "high_chord": 767.4
                    },
                    {
                        "degree": 6.574572578596119,
                        "station": 5310.8,
                        "low_chord": 721.31,
                        "high_chord": 769.44
                    },
                    {
                        "degree": 8.530765609947073,
                        "station": 5312,
                        "low_chord": 721.31,
                        "high_chord": 769.62
                    },
                    {
                        "degree": 3.8306085036856365,
                        "station": 5323.5,
                        "low_chord": 721.31,
                        "high_chord": 770.39
                    },
                    {
                        "degree": 7.2531946127252285,
                        "station": 5325.7,
                        "low_chord": 721.31,
                        "high_chord": 770.67
                    },
                    {
                        "degree": 5.76731599740903,
                        "station": 5335.7,
                        "low_chord": 721.31,
                        "high_chord": 771.68
                    }
                ],
                "down_degress": [
                    {
                        "degree": -9.668668661083178,
                        "station": 4634.6,
                        "low_chord": 721.31,
                        "high_chord": 766.26
                    },
                    {
                        "degree": -4.803153744353504,
                        "station": 4649,
                        "low_chord": 721.31,
                        "high_chord": 765.05
                    },
                    {
                        "degree": -9.727578551404445,
                        "station": 4649.7,
                        "low_chord": 721.31,
                        "high_chord": 764.93
                    },
                    {
                        "degree": -7.477330306656398,
                        "station": 4651.3,
                        "low_chord": 721.31,
                        "high_chord": 764.72
                    },
                    {
                        "degree": -8.571366353941215,
                        "station": 4665.1,
                        "low_chord": 721.31,
                        "high_chord": 762.64
                    },
                    {
                        "degree": -6.852469770553889,
                        "station": 4688.4,
                        "low_chord": 721.31,
                        "high_chord": 759.84
                    },
                    {
                        "degree": -9.419101864566146,
                        "station": 4701.3,
                        "low_chord": 721.31,
                        "high_chord": 757.7
                    },
                    {
                        "degree": -4.289153328835212,
                        "station": 4701.7,
                        "low_chord": 721.31,
                        "high_chord": 757.67
                    },
                    {
                        "degree": -6.60483549674952,
                        "station": 4703.6,
                        "low_chord": 721.31,
                        "high_chord": 757.45
                    },
                    {
                        "degree": -6.914867720082606,
                        "station": 4708.3,
                        "low_chord": 721.31,
                        "high_chord": 756.88
                    },
                    {
                        "degree": -7.975620399073475,
                        "station": 4727,
                        "low_chord": 721.31,
                        "high_chord": 754.26
                    },
                    {
                        "degree": -5.428381094220301,
                        "station": 4763.2,
                        "low_chord": 721.31,
                        "high_chord": 750.82
                    },
                    {
                        "degree": -7.5195703251904,
                        "station": 4765.7,
                        "low_chord": 721.31,
                        "high_chord": 750.49
                    },
                    {
                        "degree": -2.4434668001538236,
                        "station": 4788.9,
                        "low_chord": 721.31,
                        "high_chord": 749.5
                    },
                    {
                        "degree": -1.367997412225933,
                        "station": 4795.6,
                        "low_chord": 721.31,
                        "high_chord": 749.34
                    },
                    {
                        "degree": -0.2407371527221385,
                        "station": 4807.5,
                        "low_chord": 721.31,
                        "high_chord": 749.29
                    },
                    {
                        "degree": 3.2992816989925657,
                        "station": 4816,
                        "low_chord": 721.31,
                        "high_chord": 749.78
                    },
                    {
                        "degree": 8.709516422005624,
                        "station": 4820.7,
                        "low_chord": 721.31,
                        "high_chord": 750.5
                    },
                    {
                        "degree": -5.194428907736408,
                        "station": 4822.9,
                        "low_chord": 721.31,
                        "high_chord": 750.3
                    },
                    {
                        "degree": -9.67335543240232,
                        "station": 4827.3,
                        "low_chord": 721.31,
                        "high_chord": 749.55
                    },
                    {
                        "degree": -2.5774355757558816,
                        "station": 4860.4,
                        "low_chord": 721.31,
                        "high_chord": 748.06
                    },
                    {
                        "degree": 0.7761268781677042,
                        "station": 4901,
                        "low_chord": 721.31,
                        "high_chord": 748.61
                    },
                    {
                        "degree": 2.8689744869594445,
                        "station": 4944.5,
                        "low_chord": 721.31,
                        "high_chord": 750.79
                    },
                    {
                        "degree": -0.2515408305647964,
                        "station": 4985.5,
                        "low_chord": 721.31,
                        "high_chord": 750.61
                    },
                    {
                        "degree": -2.726310993906413,
                        "station": 4987.6,
                        "low_chord": 721.31,
                        "high_chord": 750.51
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 4987.6,
                        "low_chord": 747.71,
                        "high_chord": 750.51
                    },
                    {
                        "degree": 0.5555780242457545,
                        "station": 5004.1,
                        "low_chord": 747.86,
                        "high_chord": 750.67
                    },
                    {
                        "degree": 0.4714103331047444,
                        "station": 5019.9,
                        "low_chord": 748,
                        "high_chord": 750.8
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 5019.9,
                        "low_chord": 721.31,
                        "high_chord": 750.8
                    },
                    {
                        "degree": 4.208519456764294,
                        "station": 5025.2,
                        "low_chord": 721.31,
                        "high_chord": 751.19
                    },
                    {
                        "degree": -0.5035366421387346,
                        "station": 5067.3,
                        "low_chord": 721.31,
                        "high_chord": 750.82
                    },
                    {
                        "degree": 1.6325581465491952,
                        "station": 5108,
                        "low_chord": 721.31,
                        "high_chord": 751.98
                    },
                    {
                        "degree": 1.6971561896002552,
                        "station": 5151.2,
                        "low_chord": 721.31,
                        "high_chord": 753.26
                    },
                    {
                        "degree": 2.017539764476505,
                        "station": 5195.2,
                        "low_chord": 721.31,
                        "high_chord": 754.81
                    },
                    {
                        "degree": -2.968234029871626,
                        "station": 5197.9,
                        "low_chord": 721.31,
                        "high_chord": 754.67
                    },
                    {
                        "degree": 3.433630362450652,
                        "station": 5205.9,
                        "low_chord": 721.31,
                        "high_chord": 755.15
                    },
                    {
                        "degree": 0.3370301098573568,
                        "station": 5207.6,
                        "low_chord": 721.31,
                        "high_chord": 755.16
                    },
                    {
                        "degree": 8.397302586691264,
                        "station": 5213.9,
                        "low_chord": 721.31,
                        "high_chord": 756.09
                    },
                    {
                        "degree": 12.73086878980428,
                        "station": 5219.3,
                        "low_chord": 721.31,
                        "high_chord": 757.31
                    },
                    {
                        "degree": 6.214390041356122,
                        "station": 5228.3,
                        "low_chord": 721.31,
                        "high_chord": 758.29
                    },
                    {
                        "degree": 4.28915332882161,
                        "station": 5230.3,
                        "low_chord": 721.31,
                        "high_chord": 758.44
                    },
                    {
                        "degree": -3.0168513228534573,
                        "station": 5237.7,
                        "low_chord": 721.31,
                        "high_chord": 758.05
                    },
                    {
                        "degree": 0.7392593554091894,
                        "station": 5240.8,
                        "low_chord": 721.31,
                        "high_chord": 758.09
                    },
                    {
                        "degree": 12.264773727892246,
                        "station": 5254.6,
                        "low_chord": 721.31,
                        "high_chord": 761.09
                    },
                    {
                        "degree": 13.360218444768723,
                        "station": 5256.2,
                        "low_chord": 721.31,
                        "high_chord": 761.47
                    },
                    {
                        "degree": 11.309932474017636,
                        "station": 5259.6,
                        "low_chord": 721.31,
                        "high_chord": 762.15
                    },
                    {
                        "degree": 8.69550287742522,
                        "station": 5268.1,
                        "low_chord": 721.31,
                        "high_chord": 763.45
                    },
                    {
                        "degree": 7.440052910931557,
                        "station": 5285.1,
                        "low_chord": 721.31,
                        "high_chord": 765.67
                    },
                    {
                        "degree": 13.400091627732317,
                        "station": 5291.9,
                        "low_chord": 721.31,
                        "high_chord": 767.29
                    },
                    {
                        "degree": 5.237476066810002,
                        "station": 5293.1,
                        "low_chord": 721.31,
                        "high_chord": 767.4
                    },
                    {
                        "degree": 6.574572578596119,
                        "station": 5310.8,
                        "low_chord": 721.31,
                        "high_chord": 769.44
                    },
                    {
                        "degree": 8.530765609947073,
                        "station": 5312,
                        "low_chord": 721.31,
                        "high_chord": 769.62
                    },
                    {
                        "degree": 3.8306085036856365,
                        "station": 5323.5,
                        "low_chord": 721.31,
                        "high_chord": 770.39
                    },
                    {
                        "degree": 7.2531946127252285,
                        "station": 5325.7,
                        "low_chord": 721.31,
                        "high_chord": 770.67
                    },
                    {
                        "degree": 5.76731599740903,
                        "station": 5335.7,
                        "low_chord": 721.31,
                        "high_chord": 771.68
                    }
                ],
                "ulr": [
                    {
                        "degree": -2.726310993906413,
                        "station": 4987.6,
                        "low_chord": 721.31,
                        "high_chord": 750.51
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 4987.6,
                        "low_chord": 747.71,
                        "high_chord": 750.51
                    }
                ],
                "urr": [],
                "dlr": [
                    {
                        "degree": -2.726310993906413,
                        "station": 4987.6,
                        "low_chord": 721.31,
                        "high_chord": 750.51
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 4987.6,
                        "low_chord": 747.71,
                        "high_chord": 750.51
                    }
                ],
                "drr": [],
                "ulr_high_elev": 750.51,
                "ulr_high_sta": 4987.6,
                "ulr_top_rail": 750.51,
                "dlr_high_elev": 750.51,
                "dlr_high_sta": 4987.6,
                "dlr_top_rail": 750.51,
                "down_dist": "18.00",
                "up_left_calc": "4",
                "up_right_calc": "3",
                "down_left_calc": "4",
                "down_right_calc": "3",
                "around_structure_table": {},
                "skew": "-18"
            },
            {
                "cross_section": "24681",
                "up_cross_section": "24717",
                "down_cross_section": "24654",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_thalweg": [
                    4988.5,
                    709.21
                ],
                "down_thalweg": [
                    4998.5,
                    708.79
                ],
                "up_bank_left": 4960.1,
                "up_bank_left_elev": 718.6,
                "up_bank_right": 5033,
                "up_bank_right_elev": 718.38,
                "down_bank_left": 4976.1,
                "down_bank_left_elev": 717.77,
                "down_bank_right": 5023.5,
                "down_bank_right_elev": 718.05,
                "up_dist": "13.50",
                "bridge_us_width": 45,
                "dist_to_xs": 13.5,
                "up_left_opening_station": 4959.6,
                "up_right_opening_station": null,
                "down_left_opening_station": 4959.6,
                "down_right_opening_station": null,
                "up_left_low_chord_elev": 718.56,
                "up_right_low_chord_elev": null,
                "down_left_low_chord_elev": 718.56,
                "down_right_low_chord_elev": null,
                "up_degress": [
                    {
                        "degree": -3.2450714816790875,
                        "station": 4530.5,
                        "low_chord": 689.12,
                        "high_chord": 737.67
                    },
                    {
                        "degree": -1.4893547265513476,
                        "station": 4535.5,
                        "low_chord": 689.12,
                        "high_chord": 737.54
                    },
                    {
                        "degree": -3.3436995887943177,
                        "station": 4590.1,
                        "low_chord": 689.12,
                        "high_chord": 734.35
                    },
                    {
                        "degree": -1.6221018310935866,
                        "station": 4601.4,
                        "low_chord": 689.12,
                        "high_chord": 734.03
                    },
                    {
                        "degree": -3.730304235590299,
                        "station": 4624.1,
                        "low_chord": 689.12,
                        "high_chord": 732.55
                    },
                    {
                        "degree": -2.420339674521616,
                        "station": 4633.8,
                        "low_chord": 689.12,
                        "high_chord": 732.14
                    },
                    {
                        "degree": -7.495857639731279,
                        "station": 4635.7,
                        "low_chord": 689.12,
                        "high_chord": 731.89
                    },
                    {
                        "degree": -2.5448043798123328,
                        "station": 4639.3,
                        "low_chord": 689.12,
                        "high_chord": 731.73
                    },
                    {
                        "degree": -6.104264141288477,
                        "station": 4646.5,
                        "low_chord": 689.12,
                        "high_chord": 730.96
                    },
                    {
                        "degree": -4.049581703271576,
                        "station": 4680.4,
                        "low_chord": 689.12,
                        "high_chord": 728.56
                    },
                    {
                        "degree": -1.9091524329962002,
                        "station": 4692.7,
                        "low_chord": 689.12,
                        "high_chord": 728.15
                    },
                    {
                        "degree": -4.14573251284114,
                        "station": 4722.5,
                        "low_chord": 689.12,
                        "high_chord": 725.99
                    },
                    {
                        "degree": -2.9564464948365194,
                        "station": 4762,
                        "low_chord": 689.12,
                        "high_chord": 723.95
                    },
                    {
                        "degree": -0.7796096423402514,
                        "station": 4793.6,
                        "low_chord": 689.12,
                        "high_chord": 723.52
                    },
                    {
                        "degree": -1.9888453803275234,
                        "station": 4870.2,
                        "low_chord": 689.12,
                        "high_chord": 720.86
                    },
                    {
                        "degree": -0.0412793729104952,
                        "station": 4939.6,
                        "low_chord": 689.12,
                        "high_chord": 720.81
                    },
                    {
                        "degree": -0.45835645800034025,
                        "station": 4959.6,
                        "low_chord": 689.12,
                        "high_chord": 720.65
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 4959.6,
                        "low_chord": 718.56,
                        "high_chord": 720.65
                    },
                    {
                        "degree": -0.4583564580000147,
                        "station": 4962.1,
                        "low_chord": 718.56,
                        "high_chord": 720.63
                    },
                    {
                        "degree": 0.13957531346072383,
                        "station": 5044.2,
                        "low_chord": 718.56,
                        "high_chord": 720.83
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 5044.2,
                        "low_chord": 689.12,
                        "high_chord": 720.83
                    },
                    {
                        "degree": 0,
                        "station": 5044.9,
                        "low_chord": 689.12,
                        "high_chord": 720.83
                    },
                    {
                        "degree": 0.7812576616086568,
                        "station": 5053.7,
                        "low_chord": 689.12,
                        "high_chord": 720.95
                    },
                    {
                        "degree": 0.4148932204393384,
                        "station": 5082.7,
                        "low_chord": 689.12,
                        "high_chord": 721.16
                    },
                    {
                        "degree": 1.1025373863543202,
                        "station": 5135.7,
                        "low_chord": 689.12,
                        "high_chord": 722.18
                    },
                    {
                        "degree": 2.06953733630065,
                        "station": 5191.6,
                        "low_chord": 689.12,
                        "high_chord": 724.2
                    },
                    {
                        "degree": 2.0030515002438856,
                        "station": 5230.2,
                        "low_chord": 689.12,
                        "high_chord": 725.55
                    },
                    {
                        "degree": 2.862405226111748,
                        "station": 5234.6,
                        "low_chord": 689.12,
                        "high_chord": 725.77
                    },
                    {
                        "degree": 3.190234292532936,
                        "station": 5240.7,
                        "low_chord": 689.12,
                        "high_chord": 726.11
                    },
                    {
                        "degree": 8.228802996425026,
                        "station": 5247.2,
                        "low_chord": 689.12,
                        "high_chord": 727.05
                    },
                    {
                        "degree": 3.5423611921938214,
                        "station": 5266.1,
                        "low_chord": 689.12,
                        "high_chord": 728.22
                    },
                    {
                        "degree": 2.817984162899384,
                        "station": 5285.4,
                        "low_chord": 689.12,
                        "high_chord": 729.17
                    },
                    {
                        "degree": 3.5441147080377045,
                        "station": 5300.9,
                        "low_chord": 689.12,
                        "high_chord": 730.13
                    },
                    {
                        "degree": -0.3819662047286781,
                        "station": 5303.9,
                        "low_chord": 689.12,
                        "high_chord": 730.11
                    },
                    {
                        "degree": 5.098391821152148,
                        "station": 5330.8,
                        "low_chord": 689.12,
                        "high_chord": 732.51
                    },
                    {
                        "degree": 2.4195092166564587,
                        "station": 5345,
                        "low_chord": 689.12,
                        "high_chord": 733.11
                    },
                    {
                        "degree": 5.645380578005195,
                        "station": 5353.7,
                        "low_chord": 689.12,
                        "high_chord": 733.97
                    },
                    {
                        "degree": 5.150410485650367,
                        "station": 5376,
                        "low_chord": 689.12,
                        "high_chord": 735.98
                    },
                    {
                        "degree": 2.862405226108499,
                        "station": 5377.6,
                        "low_chord": 689.12,
                        "high_chord": 736.06
                    },
                    {
                        "degree": 3.8901244040626177,
                        "station": 5385.1,
                        "low_chord": 689.12,
                        "high_chord": 736.57
                    },
                    {
                        "degree": 5.026333546613261,
                        "station": 5401.7,
                        "low_chord": 689.12,
                        "high_chord": 738.03
                    },
                    {
                        "degree": 7.6210713092970215,
                        "station": 5408.8,
                        "low_chord": 689.12,
                        "high_chord": 738.98
                    },
                    {
                        "degree": 5.194428907738544,
                        "station": 5409.9,
                        "low_chord": 689.12,
                        "high_chord": 739.08
                    },
                    {
                        "degree": 3.392849874587153,
                        "station": 5423.9,
                        "low_chord": 689.12,
                        "high_chord": 739.91
                    },
                    {
                        "degree": 4.622370241683471,
                        "station": 5428.6,
                        "low_chord": 689.12,
                        "high_chord": 740.29
                    },
                    {
                        "degree": 6.792930782237138,
                        "station": 5435.4,
                        "low_chord": 689.12,
                        "high_chord": 741.1
                    }
                ],
                "down_degress": [
                    {
                        "degree": -3.2450714816790875,
                        "station": 4530.5,
                        "low_chord": 689.12,
                        "high_chord": 737.67
                    },
                    {
                        "degree": -1.4893547265513476,
                        "station": 4535.5,
                        "low_chord": 689.12,
                        "high_chord": 737.54
                    },
                    {
                        "degree": -3.3436995887943177,
                        "station": 4590.1,
                        "low_chord": 689.12,
                        "high_chord": 734.35
                    },
                    {
                        "degree": -1.6221018310935866,
                        "station": 4601.4,
                        "low_chord": 689.12,
                        "high_chord": 734.03
                    },
                    {
                        "degree": -3.730304235590299,
                        "station": 4624.1,
                        "low_chord": 689.12,
                        "high_chord": 732.55
                    },
                    {
                        "degree": -2.420339674521616,
                        "station": 4633.8,
                        "low_chord": 689.12,
                        "high_chord": 732.14
                    },
                    {
                        "degree": -7.495857639731279,
                        "station": 4635.7,
                        "low_chord": 689.12,
                        "high_chord": 731.89
                    },
                    {
                        "degree": -2.5448043798123328,
                        "station": 4639.3,
                        "low_chord": 689.12,
                        "high_chord": 731.73
                    },
                    {
                        "degree": -6.104264141288477,
                        "station": 4646.5,
                        "low_chord": 689.12,
                        "high_chord": 730.96
                    },
                    {
                        "degree": -4.049581703271576,
                        "station": 4680.4,
                        "low_chord": 689.12,
                        "high_chord": 728.56
                    },
                    {
                        "degree": -1.9091524329962002,
                        "station": 4692.7,
                        "low_chord": 689.12,
                        "high_chord": 728.15
                    },
                    {
                        "degree": -4.14573251284114,
                        "station": 4722.5,
                        "low_chord": 689.12,
                        "high_chord": 725.99
                    },
                    {
                        "degree": -2.9564464948365194,
                        "station": 4762,
                        "low_chord": 689.12,
                        "high_chord": 723.95
                    },
                    {
                        "degree": -0.7796096423402514,
                        "station": 4793.6,
                        "low_chord": 689.12,
                        "high_chord": 723.52
                    },
                    {
                        "degree": -1.9888453803275234,
                        "station": 4870.2,
                        "low_chord": 689.12,
                        "high_chord": 720.86
                    },
                    {
                        "degree": -0.0412793729104952,
                        "station": 4939.6,
                        "low_chord": 689.12,
                        "high_chord": 720.81
                    },
                    {
                        "degree": -0.45835645800034025,
                        "station": 4959.6,
                        "low_chord": 689.12,
                        "high_chord": 720.65
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 4959.6,
                        "low_chord": 718.56,
                        "high_chord": 720.65
                    },
                    {
                        "degree": -0.4583564580000147,
                        "station": 4962.1,
                        "low_chord": 718.56,
                        "high_chord": 720.63
                    },
                    {
                        "degree": 0.13957531346072383,
                        "station": 5044.2,
                        "low_chord": 718.56,
                        "high_chord": 720.83
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 5044.2,
                        "low_chord": 689.12,
                        "high_chord": 720.83
                    },
                    {
                        "degree": 0,
                        "station": 5044.9,
                        "low_chord": 689.12,
                        "high_chord": 720.83
                    },
                    {
                        "degree": 0.7812576616086568,
                        "station": 5053.7,
                        "low_chord": 689.12,
                        "high_chord": 720.95
                    },
                    {
                        "degree": 0.4148932204393384,
                        "station": 5082.7,
                        "low_chord": 689.12,
                        "high_chord": 721.16
                    },
                    {
                        "degree": 1.1025373863543202,
                        "station": 5135.7,
                        "low_chord": 689.12,
                        "high_chord": 722.18
                    },
                    {
                        "degree": 2.06953733630065,
                        "station": 5191.6,
                        "low_chord": 689.12,
                        "high_chord": 724.2
                    },
                    {
                        "degree": 2.0030515002438856,
                        "station": 5230.2,
                        "low_chord": 689.12,
                        "high_chord": 725.55
                    },
                    {
                        "degree": 2.862405226111748,
                        "station": 5234.6,
                        "low_chord": 689.12,
                        "high_chord": 725.77
                    },
                    {
                        "degree": 3.190234292532936,
                        "station": 5240.7,
                        "low_chord": 689.12,
                        "high_chord": 726.11
                    },
                    {
                        "degree": 8.228802996425026,
                        "station": 5247.2,
                        "low_chord": 689.12,
                        "high_chord": 727.05
                    },
                    {
                        "degree": 3.5423611921938214,
                        "station": 5266.1,
                        "low_chord": 689.12,
                        "high_chord": 728.22
                    },
                    {
                        "degree": 2.817984162899384,
                        "station": 5285.4,
                        "low_chord": 689.12,
                        "high_chord": 729.17
                    },
                    {
                        "degree": 3.5441147080377045,
                        "station": 5300.9,
                        "low_chord": 689.12,
                        "high_chord": 730.13
                    },
                    {
                        "degree": -0.3819662047286781,
                        "station": 5303.9,
                        "low_chord": 689.12,
                        "high_chord": 730.11
                    },
                    {
                        "degree": 5.098391821152148,
                        "station": 5330.8,
                        "low_chord": 689.12,
                        "high_chord": 732.51
                    },
                    {
                        "degree": 2.4195092166564587,
                        "station": 5345,
                        "low_chord": 689.12,
                        "high_chord": 733.11
                    },
                    {
                        "degree": 5.645380578005195,
                        "station": 5353.7,
                        "low_chord": 689.12,
                        "high_chord": 733.97
                    },
                    {
                        "degree": 5.150410485650367,
                        "station": 5376,
                        "low_chord": 689.12,
                        "high_chord": 735.98
                    },
                    {
                        "degree": 2.862405226108499,
                        "station": 5377.6,
                        "low_chord": 689.12,
                        "high_chord": 736.06
                    },
                    {
                        "degree": 3.8901244040626177,
                        "station": 5385.1,
                        "low_chord": 689.12,
                        "high_chord": 736.57
                    },
                    {
                        "degree": 5.026333546613261,
                        "station": 5401.7,
                        "low_chord": 689.12,
                        "high_chord": 738.03
                    },
                    {
                        "degree": 7.6210713092970215,
                        "station": 5408.8,
                        "low_chord": 689.12,
                        "high_chord": 738.98
                    },
                    {
                        "degree": 5.194428907738544,
                        "station": 5409.9,
                        "low_chord": 689.12,
                        "high_chord": 739.08
                    },
                    {
                        "degree": 3.392849874587153,
                        "station": 5423.9,
                        "low_chord": 689.12,
                        "high_chord": 739.91
                    },
                    {
                        "degree": 4.622370241683471,
                        "station": 5428.6,
                        "low_chord": 689.12,
                        "high_chord": 740.29
                    },
                    {
                        "degree": 6.792930782237138,
                        "station": 5435.4,
                        "low_chord": 689.12,
                        "high_chord": 741.1
                    }
                ],
                "ulr": [
                    {
                        "degree": -0.45835645800034025,
                        "station": 4959.6,
                        "low_chord": 689.12,
                        "high_chord": 720.65
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 4959.6,
                        "low_chord": 718.56,
                        "high_chord": 720.65
                    }
                ],
                "urr": [],
                "dlr": [
                    {
                        "degree": -0.45835645800034025,
                        "station": 4959.6,
                        "low_chord": 689.12,
                        "high_chord": 720.65
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 4959.6,
                        "low_chord": 718.56,
                        "high_chord": 720.65
                    }
                ],
                "drr": [],
                "ulr_high_elev": 720.65,
                "ulr_high_sta": 4959.6,
                "ulr_top_rail": 720.65,
                "dlr_high_elev": 720.65,
                "dlr_high_sta": 4959.6,
                "dlr_top_rail": 720.65,
                "down_dist": "4.50",
                "up_left_calc": "4",
                "up_right_calc": "3",
                "down_left_calc": "4",
                "down_right_calc": "3",
                "around_structure_table": {},
                "skew": "11"
            },
            {
                "cross_section": "1423.44",
                "up_cross_section": "1452.05",
                "down_cross_section": "1398.04",
                "error_id": "T-CES-01",
                "up_hasError": false,
                "down_hasError": false,
                "type": "Bridge",
                "structure_opening": "structure",
                "up_thalweg": [
                    171.56,
                    645.59
                ],
                "down_thalweg": [
                    179.35,
                    644.68
                ],
                "up_bank_left": 167.04,
                "up_bank_left_elev": 646.99,
                "up_bank_right": 182.43,
                "up_bank_right_elev": 646.93,
                "down_bank_left": 174.83,
                "down_bank_left_elev": 646.15,
                "down_bank_right": 189.55,
                "down_bank_right_elev": 646.11,
                "up_dist": "18.00",
                "bridge_us_width": 24,
                "dist_to_xs": 18,
                "up_left_opening_station": 157.5,
                "up_right_opening_station": 260.81,
                "down_left_opening_station": 136.03,
                "down_right_opening_station": 136.03,
                "up_left_low_chord_elev": 651.02,
                "up_right_low_chord_elev": 0,
                "down_left_low_chord_elev": 0,
                "down_right_low_chord_elev": 0,
                "up_degress": [
                    {
                        "degree": -5.552971033040746,
                        "station": -3.11,
                        "low_chord": 0,
                        "high_chord": 669.81
                    },
                    {
                        "degree": -4.698680517295186,
                        "station": -2.38,
                        "low_chord": 0,
                        "high_chord": 669.75
                    },
                    {
                        "degree": -8.130102354148685,
                        "station": -2.17,
                        "low_chord": 0,
                        "high_chord": 669.72
                    },
                    {
                        "degree": -4.945966547105897,
                        "station": -1.13,
                        "low_chord": 0,
                        "high_chord": 669.63
                    },
                    {
                        "degree": -6.241914347419475,
                        "station": -0.49,
                        "low_chord": 0,
                        "high_chord": 669.56
                    },
                    {
                        "degree": -5.6730221399244645,
                        "station": 1.02,
                        "low_chord": 0,
                        "high_chord": 669.41
                    },
                    {
                        "degree": -4.844000375076295,
                        "station": 1.61,
                        "low_chord": 0,
                        "high_chord": 669.36
                    },
                    {
                        "degree": -6.170175095032741,
                        "station": 2.35,
                        "low_chord": 0,
                        "high_chord": 669.28
                    },
                    {
                        "degree": -5.194428907730108,
                        "station": 3.23,
                        "low_chord": 0,
                        "high_chord": 669.2
                    },
                    {
                        "degree": -7.594643368605956,
                        "station": 3.53,
                        "low_chord": 0,
                        "high_chord": 669.16
                    },
                    {
                        "degree": -5.355825042850345,
                        "station": 4.49,
                        "low_chord": 0,
                        "high_chord": 669.07
                    },
                    {
                        "degree": -6.7098368077634865,
                        "station": 5,
                        "low_chord": 0,
                        "high_chord": 669.01
                    },
                    {
                        "degree": -3.814074834286898,
                        "station": 5.3,
                        "low_chord": 0,
                        "high_chord": 668.99
                    },
                    {
                        "degree": -7.594643368584623,
                        "station": 5.6,
                        "low_chord": 0,
                        "high_chord": 668.95
                    },
                    {
                        "degree": -3.945186229056341,
                        "station": 5.89,
                        "low_chord": 0,
                        "high_chord": 668.93
                    },
                    {
                        "degree": -6.225829064425999,
                        "station": 6.99,
                        "low_chord": 0,
                        "high_chord": 668.81
                    },
                    {
                        "degree": -3.0127875041806127,
                        "station": 7.18,
                        "low_chord": 0,
                        "high_chord": 668.8
                    },
                    {
                        "degree": -7.125016348895378,
                        "station": 7.58,
                        "low_chord": 0,
                        "high_chord": 668.75
                    },
                    {
                        "degree": -4.763641690721861,
                        "station": 8.06,
                        "low_chord": 0,
                        "high_chord": 668.71
                    },
                    {
                        "degree": -6.398956627369154,
                        "station": 9.13,
                        "low_chord": 0,
                        "high_chord": 668.59
                    },
                    {
                        "degree": -5.492324557128684,
                        "station": 10.17,
                        "low_chord": 0,
                        "high_chord": 668.49
                    },
                    {
                        "degree": -7.853313301971141,
                        "station": 10.46,
                        "low_chord": 0,
                        "high_chord": 668.45
                    },
                    {
                        "degree": -5.403791360253563,
                        "station": 11.2,
                        "low_chord": 0,
                        "high_chord": 668.38
                    },
                    {
                        "degree": -6.881723630641819,
                        "station": 11.78,
                        "low_chord": 0,
                        "high_chord": 668.31
                    },
                    {
                        "degree": -4.316027519861704,
                        "station": 12.31,
                        "low_chord": 0,
                        "high_chord": 668.27
                    },
                    {
                        "degree": -7.1250163488954,
                        "station": 12.87,
                        "low_chord": 0,
                        "high_chord": 668.2
                    },
                    {
                        "degree": -5.389311759974625,
                        "station": 13.93,
                        "low_chord": 0,
                        "high_chord": 668.1
                    },
                    {
                        "degree": -7.853313301993184,
                        "station": 14.22,
                        "low_chord": 0,
                        "high_chord": 668.06
                    },
                    {
                        "degree": -5.079607860009982,
                        "station": 14.67,
                        "low_chord": 0,
                        "high_chord": 668.02
                    },
                    {
                        "degree": -6.911227119018455,
                        "station": 15.33,
                        "low_chord": 0,
                        "high_chord": 667.94
                    },
                    {
                        "degree": -4.635463426915944,
                        "station": 15.7,
                        "low_chord": 0,
                        "high_chord": 667.91
                    },
                    {
                        "degree": -7.853313301971141,
                        "station": 15.99,
                        "low_chord": 0,
                        "high_chord": 667.87
                    },
                    {
                        "degree": -5.079607860009962,
                        "station": 16.44,
                        "low_chord": 0,
                        "high_chord": 667.83
                    },
                    {
                        "degree": -8.13010235417155,
                        "station": 16.72,
                        "low_chord": 0,
                        "high_chord": 667.79
                    },
                    {
                        "degree": -4.085616779971157,
                        "station": 17,
                        "low_chord": 0,
                        "high_chord": 667.77
                    },
                    {
                        "degree": -6.753574035533346,
                        "station": 17.76,
                        "low_chord": 0,
                        "high_chord": 667.68
                    },
                    {
                        "degree": -5.079607860009982,
                        "station": 18.21,
                        "low_chord": 0,
                        "high_chord": 667.64
                    },
                    {
                        "degree": -6.911227119028181,
                        "station": 18.87,
                        "low_chord": 0,
                        "high_chord": 667.56
                    },
                    {
                        "degree": -5.87739260664257,
                        "station": 20.23,
                        "low_chord": 0,
                        "high_chord": 667.42
                    },
                    {
                        "degree": -6.842773412631197,
                        "station": 21.23,
                        "low_chord": 0,
                        "high_chord": 667.3
                    },
                    {
                        "degree": -5.640549432151735,
                        "station": 22.04,
                        "low_chord": 0,
                        "high_chord": 667.22
                    },
                    {
                        "degree": -7.696051722026923,
                        "station": 22.41,
                        "low_chord": 0,
                        "high_chord": 667.17
                    },
                    {
                        "degree": -5.774325902658055,
                        "station": 23.3,
                        "low_chord": 0,
                        "high_chord": 667.08
                    },
                    {
                        "degree": -7.696051722026923,
                        "station": 23.67,
                        "low_chord": 0,
                        "high_chord": 667.03
                    },
                    {
                        "degree": -5.710593137494503,
                        "station": 24.47,
                        "low_chord": 0,
                        "high_chord": 666.95
                    },
                    {
                        "degree": -7.052306007841436,
                        "station": 25.44,
                        "low_chord": 0,
                        "high_chord": 666.83
                    },
                    {
                        "degree": -3.366460663426783,
                        "station": 25.61,
                        "low_chord": 0,
                        "high_chord": 666.82
                    },
                    {
                        "degree": -6.940983428747478,
                        "station": 26.76,
                        "low_chord": 0,
                        "high_chord": 666.68
                    },
                    {
                        "degree": -4.635463426898475,
                        "station": 27.13,
                        "low_chord": 0,
                        "high_chord": 666.65
                    },
                    {
                        "degree": -6.3401917459041695,
                        "station": 27.85,
                        "low_chord": 0,
                        "high_chord": 666.57
                    },
                    {
                        "degree": -8.746162262571918,
                        "station": 28.11,
                        "low_chord": 0,
                        "high_chord": 666.53
                    },
                    {
                        "degree": -4.085616779971157,
                        "station": 28.39,
                        "low_chord": 0,
                        "high_chord": 666.51
                    },
                    {
                        "degree": -7.9071627029513705,
                        "station": 28.75,
                        "low_chord": 0,
                        "high_chord": 666.46
                    },
                    {
                        "degree": -5.806726905537261,
                        "station": 29.34,
                        "low_chord": 0,
                        "high_chord": 666.4
                    },
                    {
                        "degree": -9.46232220801718,
                        "station": 29.52,
                        "low_chord": 0,
                        "high_chord": 666.37
                    },
                    {
                        "degree": -5.630682757639252,
                        "station": 30.23,
                        "low_chord": 0,
                        "high_chord": 666.3
                    },
                    {
                        "degree": -7.0379407631783435,
                        "station": 31.04,
                        "low_chord": 0,
                        "high_chord": 666.2
                    },
                    {
                        "degree": -4.573921259922608,
                        "station": 31.29,
                        "low_chord": 0,
                        "high_chord": 666.18
                    },
                    {
                        "degree": -7.471559176585665,
                        "station": 31.9,
                        "low_chord": 0,
                        "high_chord": 666.1
                    },
                    {
                        "degree": 0,
                        "station": 31.98,
                        "low_chord": 0,
                        "high_chord": 666.1
                    },
                    {
                        "degree": -7.062602670415098,
                        "station": 33.11,
                        "low_chord": 0,
                        "high_chord": 665.96
                    },
                    {
                        "degree": -5.389311759980707,
                        "station": 33.64,
                        "low_chord": 0,
                        "high_chord": 665.91
                    },
                    {
                        "degree": -7.206057001384178,
                        "station": 34.51,
                        "low_chord": 0,
                        "high_chord": 665.8
                    },
                    {
                        "degree": -5.931526924914382,
                        "station": 35.28,
                        "low_chord": 0,
                        "high_chord": 665.72
                    },
                    {
                        "degree": -7.06260267041512,
                        "station": 36.41,
                        "low_chord": 0,
                        "high_chord": 665.58
                    },
                    {
                        "degree": -6.182930165948031,
                        "station": 37.61,
                        "low_chord": 0,
                        "high_chord": 665.45
                    },
                    {
                        "degree": -7.7651660184329305,
                        "station": 38.05,
                        "low_chord": 0,
                        "high_chord": 665.39
                    },
                    {
                        "degree": -4.635463426898387,
                        "station": 38.42,
                        "low_chord": 0,
                        "high_chord": 665.36
                    },
                    {
                        "degree": -7.471559176596161,
                        "station": 39.03,
                        "low_chord": 0,
                        "high_chord": 665.28
                    },
                    {
                        "degree": -5.042451069166406,
                        "station": 39.37,
                        "low_chord": 0,
                        "high_chord": 665.25
                    },
                    {
                        "degree": -7.6668042618195456,
                        "station": 39.89,
                        "low_chord": 0,
                        "high_chord": 665.18
                    },
                    {
                        "degree": -6.625874705614761,
                        "station": 41.87,
                        "low_chord": 0,
                        "high_chord": 664.95
                    },
                    {
                        "degree": -4.573921259922608,
                        "station": 42.12,
                        "low_chord": 0,
                        "high_chord": 664.93
                    },
                    {
                        "degree": -8.13010235414865,
                        "station": 42.47,
                        "low_chord": 0,
                        "high_chord": 664.88
                    },
                    {
                        "degree": -2.862405226109108,
                        "station": 42.67,
                        "low_chord": 0,
                        "high_chord": 664.87
                    },
                    {
                        "degree": -6.458816378718928,
                        "station": 43.73,
                        "low_chord": 0,
                        "high_chord": 664.75
                    },
                    {
                        "degree": -7.815293546772315,
                        "station": 44.24,
                        "low_chord": 0,
                        "high_chord": 664.68
                    },
                    {
                        "degree": -6.037682521417444,
                        "station": 45.28,
                        "low_chord": 0,
                        "high_chord": 664.57
                    },
                    {
                        "degree": -7.721825800134925,
                        "station": 45.87,
                        "low_chord": 0,
                        "high_chord": 664.49
                    },
                    {
                        "degree": -5.194428907730051,
                        "station": 46.31,
                        "low_chord": 0,
                        "high_chord": 664.45
                    },
                    {
                        "degree": -7.214262039208393,
                        "station": 47.1,
                        "low_chord": 0,
                        "high_chord": 664.35
                    },
                    {
                        "degree": 0,
                        "station": 47.2,
                        "low_chord": 0,
                        "high_chord": 664.35
                    },
                    {
                        "degree": -7.721825800134925,
                        "station": 47.79,
                        "low_chord": 0,
                        "high_chord": 664.27
                    },
                    {
                        "degree": -5.477368728823897,
                        "station": 48.52,
                        "low_chord": 0,
                        "high_chord": 664.2
                    },
                    {
                        "degree": -7.199233638367949,
                        "station": 49.47,
                        "low_chord": 0,
                        "high_chord": 664.08
                    },
                    {
                        "degree": -5.599339336528182,
                        "station": 49.98,
                        "low_chord": 0,
                        "high_chord": 664.03
                    },
                    {
                        "degree": -8.13010235414865,
                        "station": 50.33,
                        "low_chord": 0,
                        "high_chord": 663.98
                    },
                    {
                        "degree": -6.088528154198267,
                        "station": 51.08,
                        "low_chord": 0,
                        "high_chord": 663.9
                    },
                    {
                        "degree": -7.275004957882727,
                        "station": 51.55,
                        "low_chord": 0,
                        "high_chord": 663.84
                    },
                    {
                        "degree": -5.931526924922752,
                        "station": 52.32,
                        "low_chord": 0,
                        "high_chord": 663.76
                    },
                    {
                        "degree": -7.9071627029513705,
                        "station": 52.68,
                        "low_chord": 0,
                        "high_chord": 663.71
                    },
                    {
                        "degree": -5.782392322366984,
                        "station": 53.47,
                        "low_chord": 0,
                        "high_chord": 663.63
                    },
                    {
                        "degree": -7.2445068524400975,
                        "station": 54.65,
                        "low_chord": 0,
                        "high_chord": 663.48
                    },
                    {
                        "degree": -4.573921259896719,
                        "station": 54.9,
                        "low_chord": 0,
                        "high_chord": 663.46
                    },
                    {
                        "degree": -7.326406660172079,
                        "station": 55.6,
                        "low_chord": 0,
                        "high_chord": 663.37
                    },
                    {
                        "degree": -4.635463426898475,
                        "station": 55.97,
                        "low_chord": 0,
                        "high_chord": 663.34
                    },
                    {
                        "degree": -7.815293546772423,
                        "station": 56.48,
                        "low_chord": 0,
                        "high_chord": 663.27
                    },
                    {
                        "degree": -6.519801751657205,
                        "station": 57.53,
                        "low_chord": 0,
                        "high_chord": 663.15
                    },
                    {
                        "degree": -5.906141113765183,
                        "station": 58.11,
                        "low_chord": 0,
                        "high_chord": 663.09
                    },
                    {
                        "degree": -8.365886124043758,
                        "station": 58.45,
                        "low_chord": 0,
                        "high_chord": 663.04
                    },
                    {
                        "degree": -5.599339336515532,
                        "station": 58.96,
                        "low_chord": 0,
                        "high_chord": 662.99
                    },
                    {
                        "degree": -7.386043151272501,
                        "station": 59.5,
                        "low_chord": 0,
                        "high_chord": 662.92
                    },
                    {
                        "degree": -5.85601358542366,
                        "station": 60.28,
                        "low_chord": 0,
                        "high_chord": 662.84
                    },
                    {
                        "degree": -7.224315694047857,
                        "station": 60.99,
                        "low_chord": 0,
                        "high_chord": 662.75
                    },
                    {
                        "degree": -3.366460663426853,
                        "station": 61.16,
                        "low_chord": 0,
                        "high_chord": 662.74
                    },
                    {
                        "degree": -6.981057406832212,
                        "station": 62.63,
                        "low_chord": 0,
                        "high_chord": 662.56
                    },
                    {
                        "degree": -3.576334374994183,
                        "station": 62.79,
                        "low_chord": 0,
                        "high_chord": 662.55
                    },
                    {
                        "degree": -6.483073692891372,
                        "station": 63.67,
                        "low_chord": 0,
                        "high_chord": 662.45
                    },
                    {
                        "degree": -6.888258276997124,
                        "station": 65.16,
                        "low_chord": 0,
                        "high_chord": 662.27
                    },
                    {
                        "degree": -6.009005957495863,
                        "station": 66.11,
                        "low_chord": 0,
                        "high_chord": 662.17
                    },
                    {
                        "degree": -7.199233638367895,
                        "station": 67.06,
                        "low_chord": 0,
                        "high_chord": 662.05
                    },
                    {
                        "degree": -4.969740728105874,
                        "station": 67.52,
                        "low_chord": 0,
                        "high_chord": 662.01
                    },
                    {
                        "degree": -6.458816378712818,
                        "station": 68.05,
                        "low_chord": 0,
                        "high_chord": 661.95
                    },
                    {
                        "degree": -8.13010235416385,
                        "station": 68.47,
                        "low_chord": 0,
                        "high_chord": 661.89
                    },
                    {
                        "degree": -5.782392322366933,
                        "station": 69.26,
                        "low_chord": 0,
                        "high_chord": 661.81
                    },
                    {
                        "degree": -7.471559176585665,
                        "station": 69.87,
                        "low_chord": 0,
                        "high_chord": 661.73
                    },
                    {
                        "degree": -4.7636416907219665,
                        "station": 70.35,
                        "low_chord": 0,
                        "high_chord": 661.69
                    },
                    {
                        "degree": -6.519801751660267,
                        "station": 71.05,
                        "low_chord": 0,
                        "high_chord": 661.61
                    },
                    {
                        "degree": -7.594643368595177,
                        "station": 71.65,
                        "low_chord": 0,
                        "high_chord": 661.53
                    },
                    {
                        "degree": -4.085616779971157,
                        "station": 71.93,
                        "low_chord": 0,
                        "high_chord": 661.51
                    },
                    {
                        "degree": -7.523820438632049,
                        "station": 72.46,
                        "low_chord": 0,
                        "high_chord": 661.44
                    },
                    {
                        "degree": -4.763641690739842,
                        "station": 72.82,
                        "low_chord": 0,
                        "high_chord": 661.41
                    },
                    {
                        "degree": -6.566298620745009,
                        "station": 74.21,
                        "low_chord": 0,
                        "high_chord": 661.25
                    },
                    {
                        "degree": -7.236922025971558,
                        "station": 74.84,
                        "low_chord": 0,
                        "high_chord": 661.17
                    },
                    {
                        "degree": -6.1701750950284335,
                        "station": 76.32,
                        "low_chord": 0,
                        "high_chord": 661.01
                    },
                    {
                        "degree": -7.125016348901508,
                        "station": 77.36,
                        "low_chord": 0,
                        "high_chord": 660.88
                    },
                    {
                        "degree": -4.236394799055064,
                        "station": 77.63,
                        "low_chord": 0,
                        "high_chord": 660.86
                    },
                    {
                        "degree": -6.911227119024878,
                        "station": 78.62,
                        "low_chord": 0,
                        "high_chord": 660.74
                    },
                    {
                        "degree": -4.969740728105874,
                        "station": 79.08,
                        "low_chord": 0,
                        "high_chord": 660.7
                    },
                    {
                        "degree": -7.471559176596161,
                        "station": 79.69,
                        "low_chord": 0,
                        "high_chord": 660.62
                    },
                    {
                        "degree": -6.41084002023389,
                        "station": 80.58,
                        "low_chord": 0,
                        "high_chord": 660.52
                    },
                    {
                        "degree": -5.0424510691663,
                        "station": 80.92,
                        "low_chord": 0,
                        "high_chord": 660.49
                    },
                    {
                        "degree": -7.69605172200956,
                        "station": 81.29,
                        "low_chord": 0,
                        "high_chord": 660.44
                    },
                    {
                        "degree": -5.87739260664737,
                        "station": 81.97,
                        "low_chord": 0,
                        "high_chord": 660.37
                    },
                    {
                        "degree": -11.30993247401082,
                        "station": 82.07,
                        "low_chord": 0,
                        "high_chord": 660.35
                    },
                    {
                        "degree": -6.666659890903615,
                        "station": 82.84,
                        "low_chord": 0,
                        "high_chord": 660.26
                    },
                    {
                        "degree": -6.188615963243786,
                        "station": 83.67,
                        "low_chord": 0,
                        "high_chord": 660.17
                    },
                    {
                        "degree": -5.314545669940036,
                        "station": 84.1,
                        "low_chord": 0,
                        "high_chord": 660.13
                    },
                    {
                        "degree": -7.193470055295281,
                        "station": 85.13,
                        "low_chord": 0,
                        "high_chord": 660
                    },
                    {
                        "degree": -3.012787504180641,
                        "station": 85.32,
                        "low_chord": 0,
                        "high_chord": 659.99
                    },
                    {
                        "degree": -6.505626645683453,
                        "station": 86.46,
                        "low_chord": 0,
                        "high_chord": 659.86
                    },
                    {
                        "degree": -7.49585763973978,
                        "station": 86.84,
                        "low_chord": 0,
                        "high_chord": 659.81
                    },
                    {
                        "degree": -5.885987833022958,
                        "station": 87.81,
                        "low_chord": 0,
                        "high_chord": 659.71
                    },
                    {
                        "degree": -6.94098342874196,
                        "station": 88.96,
                        "low_chord": 0,
                        "high_chord": 659.57
                    },
                    {
                        "degree": -5.04245106918531,
                        "station": 89.3,
                        "low_chord": 0,
                        "high_chord": 659.54
                    },
                    {
                        "degree": -6.620776082314721,
                        "station": 90.42,
                        "low_chord": 0,
                        "high_chord": 659.41
                    },
                    {
                        "degree": -7.471559176585665,
                        "station": 91.03,
                        "low_chord": 0,
                        "high_chord": 659.33
                    },
                    {
                        "degree": -5.389311759980707,
                        "station": 91.56,
                        "low_chord": 0,
                        "high_chord": 659.28
                    },
                    {
                        "degree": -6.340191745910722,
                        "station": 92.55,
                        "low_chord": 0,
                        "high_chord": 659.17
                    },
                    {
                        "degree": -7.495857639723069,
                        "station": 93.31,
                        "low_chord": 0,
                        "high_chord": 659.07
                    },
                    {
                        "degree": -5.87739260664737,
                        "station": 93.99,
                        "low_chord": 0,
                        "high_chord": 659
                    },
                    {
                        "degree": -7.4958576397314935,
                        "station": 94.75,
                        "low_chord": 0,
                        "high_chord": 658.9
                    },
                    {
                        "degree": -5.477368728823897,
                        "station": 95.48,
                        "low_chord": 0,
                        "high_chord": 658.83
                    },
                    {
                        "degree": -7.263244740584339,
                        "station": 96.5,
                        "low_chord": 0,
                        "high_chord": 658.7
                    },
                    {
                        "degree": 0,
                        "station": 96.58,
                        "low_chord": 0,
                        "high_chord": 658.7
                    },
                    {
                        "degree": -7.523820438643926,
                        "station": 97.11,
                        "low_chord": 0,
                        "high_chord": 658.63
                    },
                    {
                        "degree": -4.573921259896719,
                        "station": 97.36,
                        "low_chord": 0,
                        "high_chord": 658.61
                    },
                    {
                        "degree": -7.943471810598015,
                        "station": 97.79,
                        "low_chord": 0,
                        "high_chord": 658.55
                    },
                    {
                        "degree": -5.290081205366564,
                        "station": 98.33,
                        "low_chord": 0,
                        "high_chord": 658.5
                    },
                    {
                        "degree": -6.842773412629914,
                        "station": 99.58,
                        "low_chord": 0,
                        "high_chord": 658.35
                    },
                    {
                        "degree": -3.3664606634267127,
                        "station": 99.75,
                        "low_chord": 0,
                        "high_chord": 658.34
                    },
                    {
                        "degree": -6.483073692896297,
                        "station": 101.07,
                        "low_chord": 0,
                        "high_chord": 658.19
                    },
                    {
                        "degree": -7.523820438643926,
                        "station": 101.6,
                        "low_chord": 0,
                        "high_chord": 658.12
                    },
                    {
                        "degree": -5.710593137499395,
                        "station": 102.9,
                        "low_chord": 0,
                        "high_chord": 657.99
                    },
                    {
                        "degree": -7.770885872605675,
                        "station": 111.84,
                        "low_chord": 0,
                        "high_chord": 656.77
                    },
                    {
                        "degree": -6.162305336200254,
                        "station": 115.73,
                        "low_chord": 0,
                        "high_chord": 656.35
                    },
                    {
                        "degree": -4.92061603636382,
                        "station": 120.26,
                        "low_chord": 0,
                        "high_chord": 655.96
                    },
                    {
                        "degree": -4.166504885549195,
                        "station": 124.79,
                        "low_chord": 0,
                        "high_chord": 655.63
                    },
                    {
                        "degree": -3.2052159310140635,
                        "station": 128.54,
                        "low_chord": 0,
                        "high_chord": 655.42
                    },
                    {
                        "degree": -3.4165881917714644,
                        "station": 132.56,
                        "low_chord": 0,
                        "high_chord": 655.18
                    },
                    {
                        "degree": -3.626571783878607,
                        "station": 135.4,
                        "low_chord": 0,
                        "high_chord": 655
                    },
                    {
                        "degree": -0.5977412366096115,
                        "station": 149.49,
                        "low_chord": 0,
                        "high_chord": 654.853
                    },
                    {
                        "degree": 89.86453322437697,
                        "station": 149.5,
                        "low_chord": 0,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": 0,
                        "station": 157.5,
                        "low_chord": 651.02,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": 0,
                        "station": 191.5,
                        "low_chord": 651.02,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": 0,
                        "station": 199.5,
                        "low_chord": 0,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": -89.86453322437697,
                        "station": 199.51,
                        "low_chord": 0,
                        "high_chord": 654.853
                    },
                    {
                        "degree": 0,
                        "station": 210.33,
                        "low_chord": 0,
                        "high_chord": 654.853
                    },
                    {
                        "degree": 2.42707393355996,
                        "station": 214.27,
                        "low_chord": 51.5,
                        "high_chord": 655.02
                    },
                    {
                        "degree": 2.4424153106579585,
                        "station": 218.49,
                        "low_chord": 106.66,
                        "high_chord": 655.2
                    },
                    {
                        "degree": 2.2862598961489686,
                        "station": 223.75,
                        "low_chord": 175.41,
                        "high_chord": 655.41
                    },
                    {
                        "degree": 2.5327594384308,
                        "station": 230.08,
                        "low_chord": 258.14,
                        "high_chord": 655.69
                    },
                    {
                        "degree": 2.2679545359048565,
                        "station": 236.14,
                        "low_chord": 337.35,
                        "high_chord": 655.93
                    },
                    {
                        "degree": 3.017449867222642,
                        "station": 242.59,
                        "low_chord": 421.65,
                        "high_chord": 656.27
                    },
                    {
                        "degree": 3.5250597202393155,
                        "station": 247.46,
                        "low_chord": 485.3,
                        "high_chord": 656.57
                    },
                    {
                        "degree": 5.07756704863432,
                        "station": 253.65,
                        "low_chord": 566.2,
                        "high_chord": 657.12
                    },
                    {
                        "degree": 7.002827008231308,
                        "station": 260,
                        "low_chord": 649.2,
                        "high_chord": 657.9
                    },
                    {
                        "degree": 4.939215542129697,
                        "station": 260.81,
                        "low_chord": 0,
                        "high_chord": 657.97
                    },
                    {
                        "degree": 5.710593137494575,
                        "station": 261.51,
                        "low_chord": 0,
                        "high_chord": 658.04
                    },
                    {
                        "degree": 4.5480424091286755,
                        "station": 262.39,
                        "low_chord": 0,
                        "high_chord": 658.11
                    },
                    {
                        "degree": 6.911227119017608,
                        "station": 262.72,
                        "low_chord": 0,
                        "high_chord": 658.15
                    },
                    {
                        "degree": 5.710593137501792,
                        "station": 263.62,
                        "low_chord": 0,
                        "high_chord": 658.24
                    },
                    {
                        "degree": 0,
                        "station": 263.72,
                        "low_chord": 0,
                        "high_chord": 658.24
                    },
                    {
                        "degree": 5.675355885168184,
                        "station": 265.33,
                        "low_chord": 0,
                        "high_chord": 658.4
                    },
                    {
                        "degree": 0,
                        "station": 265.43,
                        "low_chord": 0,
                        "high_chord": 658.4
                    },
                    {
                        "degree": 6.225829064431728,
                        "station": 265.98,
                        "low_chord": 0,
                        "high_chord": 658.46
                    },
                    {
                        "degree": 0,
                        "station": 266.09,
                        "low_chord": 0,
                        "high_chord": 658.46
                    },
                    {
                        "degree": 5.76788889790888,
                        "station": 267.08,
                        "low_chord": 0,
                        "high_chord": 658.56
                    },
                    {
                        "degree": 0,
                        "station": 267.18,
                        "low_chord": 0,
                        "high_chord": 658.56
                    },
                    {
                        "degree": 6.009005957497648,
                        "station": 267.94,
                        "low_chord": 0,
                        "high_chord": 658.64
                    },
                    {
                        "degree": 4.950272234292426,
                        "station": 269.21,
                        "low_chord": 0,
                        "high_chord": 658.75
                    },
                    {
                        "degree": 6.632514615132381,
                        "station": 269.64,
                        "low_chord": 0,
                        "high_chord": 658.8
                    },
                    {
                        "degree": 4.513988458005745,
                        "station": 270.4,
                        "low_chord": 0,
                        "high_chord": 658.86
                    },
                    {
                        "degree": 6.1155035662798625,
                        "station": 270.96,
                        "low_chord": 0,
                        "high_chord": 658.92
                    },
                    {
                        "degree": 3.012787504180641,
                        "station": 271.15,
                        "low_chord": 0,
                        "high_chord": 658.93
                    },
                    {
                        "degree": 5.477368728832634,
                        "station": 271.88,
                        "low_chord": 0,
                        "high_chord": 659
                    },
                    {
                        "degree": 6.340191745912889,
                        "station": 272.6,
                        "low_chord": 0,
                        "high_chord": 659.08
                    },
                    {
                        "degree": 2.862405226109311,
                        "station": 272.8,
                        "low_chord": 0,
                        "high_chord": 659.09
                    },
                    {
                        "degree": 6.241914347409548,
                        "station": 273.44,
                        "low_chord": 0,
                        "high_chord": 659.16
                    },
                    {
                        "degree": 0,
                        "station": 273.54,
                        "low_chord": 0,
                        "high_chord": 659.16
                    },
                    {
                        "degree": 5.710593137500522,
                        "station": 274.64,
                        "low_chord": 0,
                        "high_chord": 659.27
                    },
                    {
                        "degree": 4.39870535500128,
                        "station": 275.29,
                        "low_chord": 0,
                        "high_chord": 659.32
                    },
                    {
                        "degree": 5.826342029555014,
                        "station": 276.76,
                        "low_chord": 0,
                        "high_chord": 659.47
                    },
                    {
                        "degree": 0,
                        "station": 276.85,
                        "low_chord": 0,
                        "high_chord": 659.47
                    },
                    {
                        "degree": 6.340191745904235,
                        "station": 277.48,
                        "low_chord": 0,
                        "high_chord": 659.54
                    },
                    {
                        "degree": 0,
                        "station": 277.58,
                        "low_chord": 0,
                        "high_chord": 659.54
                    },
                    {
                        "degree": 6.115503566291363,
                        "station": 278.14,
                        "low_chord": 0,
                        "high_chord": 659.6
                    },
                    {
                        "degree": 5.095699919558136,
                        "station": 279.71,
                        "low_chord": 0,
                        "high_chord": 659.74
                    },
                    {
                        "degree": 6.254032743919487,
                        "station": 280.44,
                        "low_chord": 0,
                        "high_chord": 659.82
                    },
                    {
                        "degree": 3.731396999157228,
                        "station": 280.9,
                        "low_chord": 0,
                        "high_chord": 659.85
                    },
                    {
                        "degree": 5.1698278875562025,
                        "station": 283,
                        "low_chord": 0,
                        "high_chord": 660.04
                    },
                    {
                        "degree": 6.009005957497648,
                        "station": 283.76,
                        "low_chord": 0,
                        "high_chord": 660.12
                    },
                    {
                        "degree": 5.403791360253487,
                        "station": 284.5,
                        "low_chord": 0,
                        "high_chord": 660.19
                    },
                    {
                        "degree": 0,
                        "station": 284.61,
                        "low_chord": 0,
                        "high_chord": 660.19
                    },
                    {
                        "degree": 5.710593137499181,
                        "station": 286.01,
                        "low_chord": 0,
                        "high_chord": 660.33
                    },
                    {
                        "degree": 4.085616779971019,
                        "station": 286.43,
                        "low_chord": 0,
                        "high_chord": 660.36
                    },
                    {
                        "degree": 6.241914347409548,
                        "station": 287.07,
                        "low_chord": 0,
                        "high_chord": 660.43
                    },
                    {
                        "degree": 5.247138901618187,
                        "station": 288.05,
                        "low_chord": 0,
                        "high_chord": 660.52
                    },
                    {
                        "degree": 0,
                        "station": 288.16,
                        "low_chord": 0,
                        "high_chord": 660.52
                    },
                    {
                        "degree": 6.009005957497648,
                        "station": 288.92,
                        "low_chord": 0,
                        "high_chord": 660.6
                    },
                    {
                        "degree": 4.467159061385321,
                        "station": 289.56,
                        "low_chord": 0,
                        "high_chord": 660.65
                    },
                    {
                        "degree": 5.906141113772544,
                        "station": 290.43,
                        "low_chord": 0,
                        "high_chord": 660.74
                    },
                    {
                        "degree": 0,
                        "station": 290.53,
                        "low_chord": 0,
                        "high_chord": 660.74
                    },
                    {
                        "degree": 5.856013585431712,
                        "station": 291.31,
                        "low_chord": 0,
                        "high_chord": 660.82
                    },
                    {
                        "degree": 2.6025622024977917,
                        "station": 291.53,
                        "low_chord": 0,
                        "high_chord": 660.83
                    },
                    {
                        "degree": 6.7889745744324195,
                        "station": 291.95,
                        "low_chord": 0,
                        "high_chord": 660.88
                    },
                    {
                        "degree": 4.807953963032195,
                        "station": 293.02,
                        "low_chord": 0,
                        "high_chord": 660.97
                    },
                    {
                        "degree": 10.304846468755612,
                        "station": 293.13,
                        "low_chord": 0,
                        "high_chord": 660.99
                    },
                    {
                        "degree": 4.0141756954074355,
                        "station": 293.7,
                        "low_chord": 0,
                        "high_chord": 661.03
                    },
                    {
                        "degree": 5.885987833029431,
                        "station": 294.67,
                        "low_chord": 0,
                        "high_chord": 661.13
                    },
                    {
                        "degree": 3.468229258914168,
                        "station": 295,
                        "low_chord": 0,
                        "high_chord": 661.15
                    },
                    {
                        "degree": 5.8347889968407545,
                        "station": 296.37,
                        "low_chord": 0,
                        "high_chord": 661.29
                    },
                    {
                        "degree": 0,
                        "station": 296.47,
                        "low_chord": 0,
                        "high_chord": 661.29
                    },
                    {
                        "degree": 5.782392322367243,
                        "station": 297.26,
                        "low_chord": 0,
                        "high_chord": 661.37
                    },
                    {
                        "degree": 0,
                        "station": 297.36,
                        "low_chord": 0,
                        "high_chord": 661.37
                    },
                    {
                        "degree": 5.710593137499395,
                        "station": 298.66,
                        "low_chord": 0,
                        "high_chord": 661.5
                    },
                    {
                        "degree": 4.332313983184797,
                        "station": 299.32,
                        "low_chord": 0,
                        "high_chord": 661.55
                    },
                    {
                        "degree": 6.044092162243071,
                        "station": 300.17,
                        "low_chord": 0,
                        "high_chord": 661.64
                    },
                    {
                        "degree": 3.9004937423783734,
                        "station": 300.61,
                        "low_chord": 0,
                        "high_chord": 661.67
                    },
                    {
                        "degree": 6.170175095032666,
                        "station": 301.35,
                        "low_chord": 0,
                        "high_chord": 661.75
                    },
                    {
                        "degree": 4.159642293709214,
                        "station": 301.9,
                        "low_chord": 0,
                        "high_chord": 661.79
                    },
                    {
                        "degree": 6.340191745912889,
                        "station": 302.62,
                        "low_chord": 0,
                        "high_chord": 661.87
                    },
                    {
                        "degree": 3.731396999157228,
                        "station": 303.08,
                        "low_chord": 0,
                        "high_chord": 661.9
                    },
                    {
                        "degree": 5.710593137503788,
                        "station": 303.78,
                        "low_chord": 0,
                        "high_chord": 661.97
                    },
                    {
                        "degree": 4.085616779971019,
                        "station": 304.2,
                        "low_chord": 0,
                        "high_chord": 662
                    },
                    {
                        "degree": 6.170175095032666,
                        "station": 304.94,
                        "low_chord": 0,
                        "high_chord": 662.08
                    },
                    {
                        "degree": 5.44033203100053,
                        "station": 305.99,
                        "low_chord": 0,
                        "high_chord": 662.18
                    },
                    {
                        "degree": 0,
                        "station": 306.09,
                        "low_chord": 0,
                        "high_chord": 662.18
                    },
                    {
                        "degree": 5.617580590132205,
                        "station": 306.7,
                        "low_chord": 0,
                        "high_chord": 662.24
                    },
                    {
                        "degree": 0,
                        "station": 306.81,
                        "low_chord": 0,
                        "high_chord": 662.24
                    },
                    {
                        "degree": 6.225829064420023,
                        "station": 307.36,
                        "low_chord": 0,
                        "high_chord": 662.3
                    },
                    {
                        "degree": 2.2906100426364486,
                        "station": 307.61,
                        "low_chord": 0,
                        "high_chord": 662.31
                    },
                    {
                        "degree": 6.458816378725296,
                        "station": 308.14,
                        "low_chord": 0,
                        "high_chord": 662.37
                    },
                    {
                        "degree": 5.194428907738239,
                        "station": 308.91,
                        "low_chord": 0,
                        "high_chord": 662.44
                    },
                    {
                        "degree": 0,
                        "station": 309.02,
                        "low_chord": 0,
                        "high_chord": 662.44
                    },
                    {
                        "degree": 6.225829064420023,
                        "station": 309.57,
                        "low_chord": 0,
                        "high_chord": 662.5
                    },
                    {
                        "degree": 0,
                        "station": 309.68,
                        "low_chord": 0,
                        "high_chord": 662.5
                    },
                    {
                        "degree": 5.5054778579812504,
                        "station": 310.51,
                        "low_chord": 0,
                        "high_chord": 662.58
                    },
                    {
                        "degree": 0,
                        "station": 310.61,
                        "low_chord": 0,
                        "high_chord": 662.58
                    },
                    {
                        "degree": 5.87739260663777,
                        "station": 311.29,
                        "low_chord": 0,
                        "high_chord": 662.65
                    },
                    {
                        "degree": 4.08561677998273,
                        "station": 311.85,
                        "low_chord": 0,
                        "high_chord": 662.69
                    },
                    {
                        "degree": 6.072456407202598,
                        "station": 312.32,
                        "low_chord": 0,
                        "high_chord": 662.74
                    },
                    {
                        "degree": 2.202598161763881,
                        "station": 312.58,
                        "low_chord": 0,
                        "high_chord": 662.75
                    },
                    {
                        "degree": 5.469094970113872,
                        "station": 313.52,
                        "low_chord": 0,
                        "high_chord": 662.84
                    },
                    {
                        "degree": 4.537772507902575,
                        "station": 314.15,
                        "low_chord": 0,
                        "high_chord": 662.89
                    },
                    {
                        "degree": 2.1210963966592233,
                        "station": 314.42,
                        "low_chord": 0,
                        "high_chord": 662.9
                    },
                    {
                        "degree": 5.5054778579812504,
                        "station": 315.25,
                        "low_chord": 0,
                        "high_chord": 662.98
                    },
                    {
                        "degree": 3.576334374993972,
                        "station": 315.73,
                        "low_chord": 0,
                        "high_chord": 663.01
                    },
                    {
                        "degree": 5.710593137494484,
                        "station": 316.23,
                        "low_chord": 0,
                        "high_chord": 663.06
                    },
                    {
                        "degree": 2.6025622025273387,
                        "station": 316.45,
                        "low_chord": 0,
                        "high_chord": 663.07
                    },
                    {
                        "degree": 5.505477857973474,
                        "station": 317.28,
                        "low_chord": 0,
                        "high_chord": 663.15
                    },
                    {
                        "degree": 3.842453127916124,
                        "station": 318.62,
                        "low_chord": 0,
                        "high_chord": 663.24
                    },
                    {
                        "degree": 5.194428907730135,
                        "station": 319.06,
                        "low_chord": 0,
                        "high_chord": 663.28
                    },
                    {
                        "degree": 3.5763343750021668,
                        "station": 319.86,
                        "low_chord": 0,
                        "high_chord": 663.33
                    },
                    {
                        "degree": 6.340191745904614,
                        "station": 320.13,
                        "low_chord": 0,
                        "high_chord": 663.36
                    },
                    {
                        "degree": 4.3707970379076615,
                        "station": 321.7,
                        "low_chord": 0,
                        "high_chord": 663.48
                    },
                    {
                        "degree": 2.0454084888851534,
                        "station": 321.98,
                        "low_chord": 0,
                        "high_chord": 663.49
                    },
                    {
                        "degree": 6.340191745904614,
                        "station": 322.25,
                        "low_chord": 0,
                        "high_chord": 663.52
                    },
                    {
                        "degree": 2.7927023657105767,
                        "station": 322.66,
                        "low_chord": 0,
                        "high_chord": 663.54
                    },
                    {
                        "degree": 4.8990924537926475,
                        "station": 323.36,
                        "low_chord": 0,
                        "high_chord": 663.6
                    },
                    {
                        "degree": 3.0664855011230974,
                        "station": 323.92,
                        "low_chord": 0,
                        "high_chord": 663.63
                    },
                    {
                        "degree": 4.537772507902575,
                        "station": 324.55,
                        "low_chord": 0,
                        "high_chord": 663.68
                    },
                    {
                        "degree": 0,
                        "station": 324.69,
                        "low_chord": 0,
                        "high_chord": 663.68
                    },
                    {
                        "degree": 4.4556028333307935,
                        "station": 325.46,
                        "low_chord": 0,
                        "high_chord": 663.74
                    },
                    {
                        "degree": 2.544804379810527,
                        "station": 325.91,
                        "low_chord": 0,
                        "high_chord": 663.76
                    },
                    {
                        "degree": 7.125016348896787,
                        "station": 326.07,
                        "low_chord": 0,
                        "high_chord": 663.78
                    },
                    {
                        "degree": 2.8155566842086084,
                        "station": 326.68,
                        "low_chord": 0,
                        "high_chord": 663.81
                    },
                    {
                        "degree": 4.467159061395437,
                        "station": 327.32,
                        "low_chord": 0,
                        "high_chord": 663.86
                    },
                    {
                        "degree": 2.489552921997005,
                        "station": 327.78,
                        "low_chord": 0,
                        "high_chord": 663.88
                    },
                    {
                        "degree": 4.467159061384926,
                        "station": 328.42,
                        "low_chord": 0,
                        "high_chord": 663.93
                    },
                    {
                        "degree": 0,
                        "station": 328.56,
                        "low_chord": 0,
                        "high_chord": 663.93
                    },
                    {
                        "degree": 4.159642293720568,
                        "station": 329.11,
                        "low_chord": 0,
                        "high_chord": 663.97
                    },
                    {
                        "degree": 0,
                        "station": 329.25,
                        "low_chord": 0,
                        "high_chord": 663.97
                    },
                    {
                        "degree": 4.398705354991701,
                        "station": 329.9,
                        "low_chord": 0,
                        "high_chord": 664.02
                    },
                    {
                        "degree": 1.847610265992903,
                        "station": 330.21,
                        "low_chord": 0,
                        "high_chord": 664.03
                    },
                    {
                        "degree": 4.332313983194239,
                        "station": 330.87,
                        "low_chord": 0,
                        "high_chord": 664.08
                    },
                    {
                        "degree": 2.2906100426364486,
                        "station": 331.37,
                        "low_chord": 0,
                        "high_chord": 664.1
                    },
                    {
                        "degree": 4.316027519861936,
                        "station": 331.9,
                        "low_chord": 0,
                        "high_chord": 664.14
                    },
                    {
                        "degree": 2.694284289853582,
                        "station": 332.75,
                        "low_chord": 0,
                        "high_chord": 664.18
                    },
                    {
                        "degree": 5.194428907758833,
                        "station": 332.97,
                        "low_chord": 0,
                        "high_chord": 664.2
                    },
                    {
                        "degree": 2.161079488224519,
                        "station": 333.5,
                        "low_chord": 0,
                        "high_chord": 664.22
                    },
                    {
                        "degree": 4.0141756954074355,
                        "station": 334.07,
                        "low_chord": 0,
                        "high_chord": 664.26
                    },
                    {
                        "degree": 1.6365770416151242,
                        "station": 334.42,
                        "low_chord": 0,
                        "high_chord": 664.27
                    },
                    {
                        "degree": 3.9909130984260988,
                        "station": 334.85,
                        "low_chord": 0,
                        "high_chord": 664.3
                    },
                    {
                        "degree": 2.082565279740992,
                        "station": 335.4,
                        "low_chord": 0,
                        "high_chord": 664.32
                    },
                    {
                        "degree": 4.014175695407035,
                        "station": 335.97,
                        "low_chord": 0,
                        "high_chord": 664.36
                    },
                    {
                        "degree": 2.161079488224519,
                        "station": 336.5,
                        "low_chord": 0,
                        "high_chord": 664.38
                    },
                    {
                        "degree": 3.632950739490086,
                        "station": 337.76,
                        "low_chord": 0,
                        "high_chord": 664.46
                    },
                    {
                        "degree": 1.7357045889267455,
                        "station": 338.42,
                        "low_chord": 0,
                        "high_chord": 664.48
                    },
                    {
                        "degree": 3.4336303624474067,
                        "station": 338.92,
                        "low_chord": 0,
                        "high_chord": 664.51
                    },
                    {
                        "degree": 2.58302066863763,
                        "station": 340.25,
                        "low_chord": 0,
                        "high_chord": 664.57
                    },
                    {
                        "degree": 1.363927531601627,
                        "station": 340.67,
                        "low_chord": 0,
                        "high_chord": 664.58
                    },
                    {
                        "degree": 3.9909130984260988,
                        "station": 341.1,
                        "low_chord": 0,
                        "high_chord": 664.61
                    },
                    {
                        "degree": 1.4320961841634259,
                        "station": 341.5,
                        "low_chord": 0,
                        "high_chord": 664.62
                    },
                    {
                        "degree": 3.632950739484937,
                        "station": 342.13,
                        "low_chord": 0,
                        "high_chord": 664.66
                    },
                    {
                        "degree": 1.3971810272950211,
                        "station": 342.54,
                        "low_chord": 0,
                        "high_chord": 664.67
                    },
                    {
                        "degree": 4.573921259922608,
                        "station": 342.79,
                        "low_chord": 0,
                        "high_chord": 664.69
                    },
                    {
                        "degree": 1.4688007143845407,
                        "station": 343.57,
                        "low_chord": 0,
                        "high_chord": 664.71
                    },
                    {
                        "degree": 2.4895529219969026,
                        "station": 344.95,
                        "low_chord": 0,
                        "high_chord": 664.77
                    },
                    {
                        "degree": 1.652304677649773,
                        "station": 345.99,
                        "low_chord": 0,
                        "high_chord": 664.8
                    },
                    {
                        "degree": 3.8140748343083684,
                        "station": 346.29,
                        "low_chord": 0,
                        "high_chord": 664.82
                    },
                    {
                        "degree": 1.4878675288264613,
                        "station": 347.06,
                        "low_chord": 0,
                        "high_chord": 664.84
                    },
                    {
                        "degree": 2.8985767992790032,
                        "station": 347.85,
                        "low_chord": 0,
                        "high_chord": 664.88
                    },
                    {
                        "degree": 1.3803540734432234,
                        "station": 348.68,
                        "low_chord": 0,
                        "high_chord": 664.9
                    },
                    {
                        "degree": 2.4895529219969026,
                        "station": 349.37,
                        "low_chord": 0,
                        "high_chord": 664.93
                    },
                    {
                        "degree": 0,
                        "station": 349.67,
                        "low_chord": 0,
                        "high_chord": 664.93
                    },
                    {
                        "degree": 2.5637702114725345,
                        "station": 350.34,
                        "low_chord": 0,
                        "high_chord": 664.96
                    },
                    {
                        "degree": 1.7899106082443217,
                        "station": 350.98,
                        "low_chord": 0,
                        "high_chord": 664.98
                    },
                    {
                        "degree": 0.881403996581367,
                        "station": 351.63,
                        "low_chord": 0,
                        "high_chord": 664.99
                    },
                    {
                        "degree": 3.270487923180385,
                        "station": 351.98,
                        "low_chord": 0,
                        "high_chord": 665.01
                    },
                    {
                        "degree": 0,
                        "station": 352.28,
                        "low_chord": 0,
                        "high_chord": 665.01
                    },
                    {
                        "degree": 2.563770211462615,
                        "station": 352.95,
                        "low_chord": 0,
                        "high_chord": 665.04
                    },
                    {
                        "degree": 0.716159945469747,
                        "station": 353.75,
                        "low_chord": 0,
                        "high_chord": 665.05
                    },
                    {
                        "degree": 2.6025622025122295,
                        "station": 354.19,
                        "low_chord": 0,
                        "high_chord": 665.07
                    },
                    {
                        "degree": 0.7638984609293004,
                        "station": 354.94,
                        "low_chord": 0,
                        "high_chord": 665.08
                    },
                    {
                        "degree": 2.602562202497456,
                        "station": 355.38,
                        "low_chord": 0,
                        "high_chord": 665.1
                    },
                    {
                        "degree": 0,
                        "station": 355.79,
                        "low_chord": 0,
                        "high_chord": 665.1
                    },
                    {
                        "degree": 2.602562202497456,
                        "station": 356.23,
                        "low_chord": 0,
                        "high_chord": 665.12
                    },
                    {
                        "degree": 0,
                        "station": 356.67,
                        "low_chord": 0,
                        "high_chord": 665.12
                    },
                    {
                        "degree": 2.02136494035426,
                        "station": 357.52,
                        "low_chord": 0,
                        "high_chord": 665.15
                    },
                    {
                        "degree": 0,
                        "station": 358,
                        "low_chord": 0,
                        "high_chord": 665.15
                    },
                    {
                        "degree": 1.7183580016538953,
                        "station": 359,
                        "low_chord": 0,
                        "high_chord": 665.18
                    },
                    {
                        "degree": 0,
                        "station": 359.55,
                        "low_chord": 0,
                        "high_chord": 665.18
                    },
                    {
                        "degree": 26.56505117733854,
                        "station": 359.57,
                        "low_chord": 0,
                        "high_chord": 665.19
                    },
                    {
                        "degree": 0,
                        "station": 360.12,
                        "low_chord": 0,
                        "high_chord": 665.19
                    },
                    {
                        "degree": 8.130102354149466,
                        "station": 360.19,
                        "low_chord": 0,
                        "high_chord": 665.2
                    },
                    {
                        "degree": 0,
                        "station": 360.75,
                        "low_chord": 0,
                        "high_chord": 665.2
                    },
                    {
                        "degree": 18.43494882292201,
                        "station": 360.78,
                        "low_chord": 0,
                        "high_chord": 665.21
                    },
                    {
                        "degree": 0,
                        "station": 361.39,
                        "low_chord": 0,
                        "high_chord": 665.21
                    },
                    {
                        "degree": 18.434948822889446,
                        "station": 361.42,
                        "low_chord": 0,
                        "high_chord": 665.22
                    },
                    {
                        "degree": 0.5787255656072304,
                        "station": 362.41,
                        "low_chord": 0,
                        "high_chord": 665.23
                    }
                ],
                "down_degress": [
                    {
                        "degree": -5.1231655371279725,
                        "station": 5.04,
                        "low_chord": 0,
                        "high_chord": 669.75
                    },
                    {
                        "degree": -8.130102354148685,
                        "station": 5.25,
                        "low_chord": 0,
                        "high_chord": 669.72
                    },
                    {
                        "degree": -4.945966547105897,
                        "station": 6.29,
                        "low_chord": 0,
                        "high_chord": 669.63
                    },
                    {
                        "degree": -6.241914347419477,
                        "station": 6.93,
                        "low_chord": 0,
                        "high_chord": 669.56
                    },
                    {
                        "degree": -4.08561677997117,
                        "station": 7.21,
                        "low_chord": 0,
                        "high_chord": 669.54
                    },
                    {
                        "degree": -6.155168343274757,
                        "station": 8.23,
                        "low_chord": 0,
                        "high_chord": 669.43
                    },
                    {
                        "degree": -3.814074834286909,
                        "station": 8.53,
                        "low_chord": 0,
                        "high_chord": 669.41
                    },
                    {
                        "degree": -6.5462907832881205,
                        "station": 9.14,
                        "low_chord": 0,
                        "high_chord": 669.34
                    },
                    {
                        "degree": -3.179830119861353,
                        "station": 9.32,
                        "low_chord": 0,
                        "high_chord": 669.33
                    },
                    {
                        "degree": -6.254032743919639,
                        "station": 10.05,
                        "low_chord": 0,
                        "high_chord": 669.25
                    },
                    {
                        "degree": -4.763641690721868,
                        "station": 10.65,
                        "low_chord": 0,
                        "high_chord": 669.2
                    },
                    {
                        "degree": -6.286893361736246,
                        "station": 11.83,
                        "low_chord": 0,
                        "high_chord": 669.07
                    },
                    {
                        "degree": -5.806726905537261,
                        "station": 12.42,
                        "low_chord": 0,
                        "high_chord": 669.01
                    },
                    {
                        "degree": -3.814074834286887,
                        "station": 12.72,
                        "low_chord": 0,
                        "high_chord": 668.99
                    },
                    {
                        "degree": -7.594643368584645,
                        "station": 13.02,
                        "low_chord": 0,
                        "high_chord": 668.95
                    },
                    {
                        "degree": -3.9451862290563295,
                        "station": 13.31,
                        "low_chord": 0,
                        "high_chord": 668.93
                    },
                    {
                        "degree": -6.709836807750889,
                        "station": 13.82,
                        "low_chord": 0,
                        "high_chord": 668.87
                    },
                    {
                        "degree": -5.194428907737454,
                        "station": 14.7,
                        "low_chord": 0,
                        "high_chord": 668.79
                    },
                    {
                        "degree": -7.594643368584602,
                        "station": 15,
                        "low_chord": 0,
                        "high_chord": 668.75
                    },
                    {
                        "degree": -4.763641690721861,
                        "station": 15.48,
                        "low_chord": 0,
                        "high_chord": 668.71
                    },
                    {
                        "degree": -6.613460482318097,
                        "station": 16.17,
                        "low_chord": 0,
                        "high_chord": 668.63
                    },
                    {
                        "degree": -5.630682757634721,
                        "station": 17.59,
                        "low_chord": 0,
                        "high_chord": 668.49
                    },
                    {
                        "degree": -7.8533133019711885,
                        "station": 17.88,
                        "low_chord": 0,
                        "high_chord": 668.45
                    },
                    {
                        "degree": -6.054191894119127,
                        "station": 18.54,
                        "low_chord": 0,
                        "high_chord": 668.38
                    },
                    {
                        "degree": 0,
                        "station": 18.62,
                        "low_chord": 0,
                        "high_chord": 668.38
                    },
                    {
                        "degree": -6.88172363064184,
                        "station": 19.2,
                        "low_chord": 0,
                        "high_chord": 668.31
                    },
                    {
                        "degree": -4.316027519861704,
                        "station": 19.73,
                        "low_chord": 0,
                        "high_chord": 668.27
                    },
                    {
                        "degree": -7.1250163488954,
                        "station": 20.29,
                        "low_chord": 0,
                        "high_chord": 668.2
                    },
                    {
                        "degree": -5.0796078600243435,
                        "station": 20.74,
                        "low_chord": 0,
                        "high_chord": 668.16
                    },
                    {
                        "degree": -8.530765609940369,
                        "station": 20.94,
                        "low_chord": 0,
                        "high_chord": 668.13
                    },
                    {
                        "degree": -4.184916125114621,
                        "station": 21.35,
                        "low_chord": 0,
                        "high_chord": 668.1
                    },
                    {
                        "degree": -7.85331330199323,
                        "station": 21.64,
                        "low_chord": 0,
                        "high_chord": 668.06
                    },
                    {
                        "degree": -5.079607860009982,
                        "station": 22.09,
                        "low_chord": 0,
                        "high_chord": 668.02
                    },
                    {
                        "degree": -6.911227119018455,
                        "station": 22.75,
                        "low_chord": 0,
                        "high_chord": 667.94
                    },
                    {
                        "degree": -4.635463426915922,
                        "station": 23.12,
                        "low_chord": 0,
                        "high_chord": 667.91
                    },
                    {
                        "degree": -6.709836807757188,
                        "station": 24.14,
                        "low_chord": 0,
                        "high_chord": 667.79
                    },
                    {
                        "degree": -4.864514437756134,
                        "station": 24.61,
                        "low_chord": 0,
                        "high_chord": 667.75
                    },
                    {
                        "degree": -7.001267557500289,
                        "station": 25.18,
                        "low_chord": 0,
                        "high_chord": 667.68
                    },
                    {
                        "degree": 0,
                        "station": 25.26,
                        "low_chord": 0,
                        "high_chord": 667.68
                    },
                    {
                        "degree": -7.0165017447166065,
                        "station": 25.91,
                        "low_chord": 0,
                        "high_chord": 667.6
                    },
                    {
                        "degree": -5.440332031010843,
                        "station": 26.54,
                        "low_chord": 0,
                        "high_chord": 667.54
                    },
                    {
                        "degree": -6.745579647483649,
                        "station": 27.47,
                        "low_chord": 0,
                        "high_chord": 667.43
                    },
                    {
                        "degree": -5.815626529485976,
                        "station": 28.55,
                        "low_chord": 0,
                        "high_chord": 667.32
                    },
                    {
                        "degree": -6.683864108038148,
                        "station": 29.83,
                        "low_chord": 0,
                        "high_chord": 667.17
                    },
                    {
                        "degree": -5.774325902658055,
                        "station": 30.72,
                        "low_chord": 0,
                        "high_chord": 667.08
                    },
                    {
                        "degree": -7.028396238952061,
                        "station": 31.45,
                        "low_chord": 0,
                        "high_chord": 666.99
                    },
                    {
                        "degree": -5.194428907730092,
                        "station": 31.89,
                        "low_chord": 0,
                        "high_chord": 666.95
                    },
                    {
                        "degree": -6.859760005529296,
                        "station": 33.22,
                        "low_chord": 0,
                        "high_chord": 666.79
                    },
                    {
                        "degree": 0,
                        "station": 33.3,
                        "low_chord": 0,
                        "high_chord": 666.79
                    },
                    {
                        "degree": -7.224315694038827,
                        "station": 34.01,
                        "low_chord": 0,
                        "high_chord": 666.7
                    },
                    {
                        "degree": -5.648247373737226,
                        "station": 34.92,
                        "low_chord": 0,
                        "high_chord": 666.61
                    },
                    {
                        "degree": -8.42696902147324,
                        "station": 35.19,
                        "low_chord": 0,
                        "high_chord": 666.57
                    },
                    {
                        "degree": -6.404352726384904,
                        "station": 36.17,
                        "low_chord": 0,
                        "high_chord": 666.46
                    },
                    {
                        "degree": -6.037682521423638,
                        "station": 37.21,
                        "low_chord": 0,
                        "high_chord": 666.35
                    },
                    {
                        "degree": -7.305759533312458,
                        "station": 37.99,
                        "low_chord": 0,
                        "high_chord": 666.25
                    },
                    {
                        "degree": 0,
                        "station": 38.08,
                        "low_chord": 0,
                        "high_chord": 666.25
                    },
                    {
                        "degree": -6.508956440501006,
                        "station": 39.57,
                        "low_chord": 0,
                        "high_chord": 666.08
                    },
                    {
                        "degree": -7.12501634890206,
                        "station": 40.53,
                        "low_chord": 0,
                        "high_chord": 665.96
                    },
                    {
                        "degree": -5.389311759980707,
                        "station": 41.06,
                        "low_chord": 0,
                        "high_chord": 665.91
                    },
                    {
                        "degree": -7.199233638367949,
                        "station": 42.01,
                        "low_chord": 0,
                        "high_chord": 665.79
                    },
                    {
                        "degree": -5.792796495026886,
                        "station": 42.7,
                        "low_chord": 0,
                        "high_chord": 665.72
                    },
                    {
                        "degree": -7.06260267041512,
                        "station": 43.83,
                        "low_chord": 0,
                        "high_chord": 665.58
                    },
                    {
                        "degree": -6.182930165948031,
                        "station": 45.03,
                        "low_chord": 0,
                        "high_chord": 665.45
                    },
                    {
                        "degree": -7.7651660184329305,
                        "station": 45.47,
                        "low_chord": 0,
                        "high_chord": 665.39
                    },
                    {
                        "degree": -4.635463426898387,
                        "station": 45.84,
                        "low_chord": 0,
                        "high_chord": 665.36
                    },
                    {
                        "degree": -7.471559176596161,
                        "station": 46.45,
                        "low_chord": 0,
                        "high_chord": 665.28
                    },
                    {
                        "degree": -5.042451069166406,
                        "station": 46.79,
                        "low_chord": 0,
                        "high_chord": 665.25
                    },
                    {
                        "degree": -7.6668042618195456,
                        "station": 47.31,
                        "low_chord": 0,
                        "high_chord": 665.18
                    },
                    {
                        "degree": -6.625874705614761,
                        "station": 49.29,
                        "low_chord": 0,
                        "high_chord": 664.95
                    },
                    {
                        "degree": -4.573921259922608,
                        "station": 49.54,
                        "low_chord": 0,
                        "high_chord": 664.93
                    },
                    {
                        "degree": -8.13010235414865,
                        "station": 49.89,
                        "low_chord": 0,
                        "high_chord": 664.88
                    },
                    {
                        "degree": -2.862405226109108,
                        "station": 50.09,
                        "low_chord": 0,
                        "high_chord": 664.87
                    },
                    {
                        "degree": -6.519801751655706,
                        "station": 51.49,
                        "low_chord": 0,
                        "high_chord": 664.71
                    },
                    {
                        "degree": -10.007979801469892,
                        "station": 51.66,
                        "low_chord": 0,
                        "high_chord": 664.68
                    },
                    {
                        "degree": -6.037682521417403,
                        "station": 52.7,
                        "low_chord": 0,
                        "high_chord": 664.57
                    },
                    {
                        "degree": -7.721825800134925,
                        "station": 53.29,
                        "low_chord": 0,
                        "high_chord": 664.49
                    },
                    {
                        "degree": -5.194428907730135,
                        "station": 53.73,
                        "low_chord": 0,
                        "high_chord": 664.45
                    },
                    {
                        "degree": -7.214262039208327,
                        "station": 54.52,
                        "low_chord": 0,
                        "high_chord": 664.35
                    },
                    {
                        "degree": 0,
                        "station": 54.62,
                        "low_chord": 0,
                        "high_chord": 664.35
                    },
                    {
                        "degree": -7.721825800134833,
                        "station": 55.21,
                        "low_chord": 0,
                        "high_chord": 664.27
                    },
                    {
                        "degree": -5.47736872882395,
                        "station": 55.94,
                        "low_chord": 0,
                        "high_chord": 664.2
                    },
                    {
                        "degree": -7.199233638367895,
                        "station": 56.89,
                        "low_chord": 0,
                        "high_chord": 664.08
                    },
                    {
                        "degree": -6.009005957495863,
                        "station": 57.84,
                        "low_chord": 0,
                        "high_chord": 663.98
                    },
                    {
                        "degree": -7.206057001384178,
                        "station": 58.71,
                        "low_chord": 0,
                        "high_chord": 663.87
                    },
                    {
                        "degree": -6.095861544596559,
                        "station": 59.74,
                        "low_chord": 0,
                        "high_chord": 663.76
                    },
                    {
                        "degree": -7.9071627029513705,
                        "station": 60.1,
                        "low_chord": 0,
                        "high_chord": 663.71
                    },
                    {
                        "degree": -5.782392322366984,
                        "station": 60.89,
                        "low_chord": 0,
                        "high_chord": 663.63
                    },
                    {
                        "degree": -8.36588612402518,
                        "station": 61.23,
                        "low_chord": 0,
                        "high_chord": 663.58
                    },
                    {
                        "degree": -6.282492088161599,
                        "station": 62.32,
                        "low_chord": 0,
                        "high_chord": 663.46
                    },
                    {
                        "degree": -7.326406660172079,
                        "station": 63.02,
                        "low_chord": 0,
                        "high_chord": 663.37
                    },
                    {
                        "degree": -4.635463426898475,
                        "station": 63.39,
                        "low_chord": 0,
                        "high_chord": 663.34
                    },
                    {
                        "degree": -7.815293546772423,
                        "station": 63.9,
                        "low_chord": 0,
                        "high_chord": 663.27
                    },
                    {
                        "degree": -4.635463426898475,
                        "station": 64.27,
                        "low_chord": 0,
                        "high_chord": 663.24
                    },
                    {
                        "degree": -12.094757077001377,
                        "station": 64.41,
                        "low_chord": 0,
                        "high_chord": 663.21
                    },
                    {
                        "degree": -5.640549432159673,
                        "station": 65.22,
                        "low_chord": 0,
                        "high_chord": 663.13
                    },
                    {
                        "degree": -7.883139316732415,
                        "station": 65.87,
                        "low_chord": 0,
                        "high_chord": 663.04
                    },
                    {
                        "degree": -5.59933933651561,
                        "station": 66.38,
                        "low_chord": 0,
                        "high_chord": 662.99
                    },
                    {
                        "degree": -7.386043151272405,
                        "station": 66.92,
                        "low_chord": 0,
                        "high_chord": 662.92
                    },
                    {
                        "degree": -5.85601358542366,
                        "station": 67.7,
                        "low_chord": 0,
                        "high_chord": 662.84
                    },
                    {
                        "degree": -7.907162702969119,
                        "station": 68.06,
                        "low_chord": 0,
                        "high_chord": 662.79
                    },
                    {
                        "degree": -5.492324557122515,
                        "station": 68.58,
                        "low_chord": 0,
                        "high_chord": 662.74
                    },
                    {
                        "degree": -7.206057001384121,
                        "station": 69.45,
                        "low_chord": 0,
                        "high_chord": 662.63
                    },
                    {
                        "degree": 0,
                        "station": 69.54,
                        "low_chord": 0,
                        "high_chord": 662.63
                    },
                    {
                        "degree": -7.815293546772531,
                        "station": 70.05,
                        "low_chord": 0,
                        "high_chord": 662.56
                    },
                    {
                        "degree": -5.7105931374944605,
                        "station": 70.75,
                        "low_chord": 0,
                        "high_chord": 662.49
                    },
                    {
                        "degree": -7.594643368598794,
                        "station": 71.2,
                        "low_chord": 0,
                        "high_chord": 662.43
                    },
                    {
                        "degree": -6.061788788728892,
                        "station": 72.33,
                        "low_chord": 0,
                        "high_chord": 662.31
                    },
                    {
                        "degree": -9.090276920814194,
                        "station": 72.58,
                        "low_chord": 0,
                        "high_chord": 662.27
                    },
                    {
                        "degree": -6.009005957495863,
                        "station": 73.53,
                        "low_chord": 0,
                        "high_chord": 662.17
                    },
                    {
                        "degree": -7.9071627029513705,
                        "station": 73.89,
                        "low_chord": 0,
                        "high_chord": 662.12
                    },
                    {
                        "degree": -5.710593137494484,
                        "station": 74.39,
                        "low_chord": 0,
                        "high_chord": 662.07
                    },
                    {
                        "degree": -6.842773412633338,
                        "station": 75.89,
                        "low_chord": 0,
                        "high_chord": 661.89
                    },
                    {
                        "degree": -4.398705354991461,
                        "station": 76.15,
                        "low_chord": 0,
                        "high_chord": 661.87
                    },
                    {
                        "degree": -6.546290783298679,
                        "station": 76.76,
                        "low_chord": 0,
                        "high_chord": 661.8
                    },
                    {
                        "degree": -7.523820438631848,
                        "station": 77.29,
                        "low_chord": 0,
                        "high_chord": 661.73
                    },
                    {
                        "degree": -4.513988457997227,
                        "station": 77.67,
                        "low_chord": 0,
                        "high_chord": 661.7
                    },
                    {
                        "degree": -7.431407971179848,
                        "station": 78.13,
                        "low_chord": 0,
                        "high_chord": 661.64
                    },
                    {
                        "degree": -6.674469047118408,
                        "station": 79.07,
                        "low_chord": 0,
                        "high_chord": 661.53
                    },
                    {
                        "degree": -4.085616779971157,
                        "station": 79.35,
                        "low_chord": 0,
                        "high_chord": 661.51
                    },
                    {
                        "degree": -7.523820438631848,
                        "station": 79.88,
                        "low_chord": 0,
                        "high_chord": 661.44
                    },
                    {
                        "degree": -4.969740728119776,
                        "station": 80.34,
                        "low_chord": 0,
                        "high_chord": 661.4
                    },
                    {
                        "degree": -7.431407971175131,
                        "station": 81.03,
                        "low_chord": 0,
                        "high_chord": 661.31
                    },
                    {
                        "degree": -6.493525312538614,
                        "station": 82.26,
                        "low_chord": 0,
                        "high_chord": 661.17
                    },
                    {
                        "degree": -5.194428907730135,
                        "station": 82.7,
                        "low_chord": 0,
                        "high_chord": 661.13
                    },
                    {
                        "degree": -7.523820438643926,
                        "station": 83.23,
                        "low_chord": 0,
                        "high_chord": 661.06
                    },
                    {
                        "degree": -6.54629078328814,
                        "station": 83.84,
                        "low_chord": 0,
                        "high_chord": 660.99
                    },
                    {
                        "degree": -5.389311759968525,
                        "station": 84.37,
                        "low_chord": 0,
                        "high_chord": 660.94
                    },
                    {
                        "degree": -8.325650330434993,
                        "station": 84.78,
                        "low_chord": 0,
                        "high_chord": 660.88
                    },
                    {
                        "degree": -4.236394799055064,
                        "station": 85.05,
                        "low_chord": 0,
                        "high_chord": 660.86
                    },
                    {
                        "degree": -7.125016348903427,
                        "station": 85.85,
                        "low_chord": 0,
                        "high_chord": 660.76
                    },
                    {
                        "degree": -5.273895957346949,
                        "station": 86.5,
                        "low_chord": 0,
                        "high_chord": 660.7
                    },
                    {
                        "degree": -7.471559176596161,
                        "station": 87.11,
                        "low_chord": 0,
                        "high_chord": 660.62
                    },
                    {
                        "degree": -6.519801751660267,
                        "station": 87.81,
                        "low_chord": 0,
                        "high_chord": 660.54
                    },
                    {
                        "degree": -5.194428907730135,
                        "station": 88.25,
                        "low_chord": 0,
                        "high_chord": 660.5
                    },
                    {
                        "degree": -6.809050179613644,
                        "station": 90.26,
                        "low_chord": 0,
                        "high_chord": 660.26
                    },
                    {
                        "degree": -4.864514437756134,
                        "station": 90.73,
                        "low_chord": 0,
                        "high_chord": 660.22
                    },
                    {
                        "degree": -7.352379359896194,
                        "station": 91.35,
                        "low_chord": 0,
                        "high_chord": 660.14
                    },
                    {
                        "degree": -3.3664606634267127,
                        "station": 91.52,
                        "low_chord": 0,
                        "high_chord": 660.13
                    },
                    {
                        "degree": -7.471559176596161,
                        "station": 92.13,
                        "low_chord": 0,
                        "high_chord": 660.05
                    },
                    {
                        "degree": 0,
                        "station": 92.21,
                        "low_chord": 0,
                        "high_chord": 660.05
                    },
                    {
                        "degree": -6.490771634473669,
                        "station": 93.88,
                        "low_chord": 0,
                        "high_chord": 659.86
                    },
                    {
                        "degree": -6.981057406830029,
                        "station": 94.86,
                        "low_chord": 0,
                        "high_chord": 659.74
                    },
                    {
                        "degree": 0,
                        "station": 94.95,
                        "low_chord": 0,
                        "high_chord": 659.74
                    },
                    {
                        "degree": -6.892423122486013,
                        "station": 95.86,
                        "low_chord": 0,
                        "high_chord": 659.63
                    },
                    {
                        "degree": -5.617580590121759,
                        "station": 96.47,
                        "low_chord": 0,
                        "high_chord": 659.57
                    },
                    {
                        "degree": -9.462322208052026,
                        "station": 96.65,
                        "low_chord": 0,
                        "high_chord": 659.54
                    },
                    {
                        "degree": -6.234480095541022,
                        "station": 97.84,
                        "low_chord": 0,
                        "high_chord": 659.41
                    },
                    {
                        "degree": -7.471559176585665,
                        "station": 98.45,
                        "low_chord": 0,
                        "high_chord": 659.33
                    },
                    {
                        "degree": -5.710593137500933,
                        "station": 99.45,
                        "low_chord": 0,
                        "high_chord": 659.23
                    },
                    {
                        "degree": -7.7651660184329305,
                        "station": 99.89,
                        "low_chord": 0,
                        "high_chord": 659.17
                    },
                    {
                        "degree": -5.35582504285046,
                        "station": 100.21,
                        "low_chord": 0,
                        "high_chord": 659.14
                    },
                    {
                        "degree": -7.666804261807139,
                        "station": 100.73,
                        "low_chord": 0,
                        "high_chord": 659.07
                    },
                    {
                        "degree": -5.87739260664737,
                        "station": 101.41,
                        "low_chord": 0,
                        "high_chord": 659
                    },
                    {
                        "degree": -7.4958576397314935,
                        "station": 102.17,
                        "low_chord": 0,
                        "high_chord": 658.9
                    },
                    {
                        "degree": -4.969740728105874,
                        "station": 102.63,
                        "low_chord": 0,
                        "high_chord": 658.86
                    },
                    {
                        "degree": -7.523820438643926,
                        "station": 103.16,
                        "low_chord": 0,
                        "high_chord": 658.79
                    },
                    {
                        "degree": 0,
                        "station": 103.24,
                        "low_chord": 0,
                        "high_chord": 658.79
                    },
                    {
                        "degree": -7.5394451395024555,
                        "station": 103.92,
                        "low_chord": 0,
                        "high_chord": 658.7
                    },
                    {
                        "degree": 0,
                        "station": 104,
                        "low_chord": 0,
                        "high_chord": 658.7
                    },
                    {
                        "degree": -7.523820438643926,
                        "station": 104.53,
                        "low_chord": 0,
                        "high_chord": 658.63
                    },
                    {
                        "degree": -4.573921259896719,
                        "station": 104.78,
                        "low_chord": 0,
                        "high_chord": 658.61
                    },
                    {
                        "degree": -7.9434718105982745,
                        "station": 105.21,
                        "low_chord": 0,
                        "high_chord": 658.55
                    },
                    {
                        "degree": -5.290081205366425,
                        "station": 105.75,
                        "low_chord": 0,
                        "high_chord": 658.5
                    },
                    {
                        "degree": -7.471559176596161,
                        "station": 106.36,
                        "low_chord": 0,
                        "high_chord": 658.42
                    },
                    {
                        "degree": -6.24191434740941,
                        "station": 107,
                        "low_chord": 0,
                        "high_chord": 658.35
                    },
                    {
                        "degree": -4.236394799055064,
                        "station": 107.27,
                        "low_chord": 0,
                        "high_chord": 658.33
                    },
                    {
                        "degree": -7.471559176596161,
                        "station": 107.88,
                        "low_chord": 0,
                        "high_chord": 658.25
                    },
                    {
                        "degree": -5.617580590121759,
                        "station": 108.49,
                        "low_chord": 0,
                        "high_chord": 658.19
                    },
                    {
                        "degree": -7.523820438643926,
                        "station": 109.02,
                        "low_chord": 0,
                        "high_chord": 658.12
                    },
                    {
                        "degree": -5.7105931374994565,
                        "station": 110.32,
                        "low_chord": 0,
                        "high_chord": 657.99
                    },
                    {
                        "degree": -7.253194612730312,
                        "station": 110.87,
                        "low_chord": 0,
                        "high_chord": 657.92
                    },
                    {
                        "degree": -4.763641690721872,
                        "station": 111.23,
                        "low_chord": 0,
                        "high_chord": 657.89
                    },
                    {
                        "degree": -7.594643368584691,
                        "station": 111.53,
                        "low_chord": 0,
                        "high_chord": 657.85
                    },
                    {
                        "degree": -4.969740728115193,
                        "station": 112.22,
                        "low_chord": 0,
                        "high_chord": 657.79
                    },
                    {
                        "degree": -7.594643368584691,
                        "station": 112.52,
                        "low_chord": 0,
                        "high_chord": 657.75
                    },
                    {
                        "degree": -3.9451862290339017,
                        "station": 112.81,
                        "low_chord": 0,
                        "high_chord": 657.73
                    },
                    {
                        "degree": -6.8427734126376185,
                        "station": 113.31,
                        "low_chord": 0,
                        "high_chord": 657.67
                    },
                    {
                        "degree": -4.484606009540643,
                        "station": 113.82,
                        "low_chord": 0,
                        "high_chord": 657.63
                    },
                    {
                        "degree": -5.710593137494404,
                        "station": 114.42,
                        "low_chord": 0,
                        "high_chord": 657.57
                    },
                    {
                        "degree": -7.4958576397400565,
                        "station": 114.8,
                        "low_chord": 0,
                        "high_chord": 657.52
                    },
                    {
                        "degree": -4.085616779971157,
                        "station": 115.08,
                        "low_chord": 0,
                        "high_chord": 657.5
                    },
                    {
                        "degree": -9.090276920814194,
                        "station": 115.33,
                        "low_chord": 0,
                        "high_chord": 657.46
                    },
                    {
                        "degree": -4.610649318666839,
                        "station": 115.95,
                        "low_chord": 0,
                        "high_chord": 657.41
                    },
                    {
                        "degree": -6.340191745904283,
                        "station": 116.49,
                        "low_chord": 0,
                        "high_chord": 657.35
                    },
                    {
                        "degree": -4.398705355003914,
                        "station": 117.01,
                        "low_chord": 0,
                        "high_chord": 657.31
                    },
                    {
                        "degree": -6.340191745904235,
                        "station": 117.64,
                        "low_chord": 0,
                        "high_chord": 657.24
                    },
                    {
                        "degree": -4.64797069138807,
                        "station": 118.87,
                        "low_chord": 0,
                        "high_chord": 657.14
                    },
                    {
                        "degree": -6.519801751651212,
                        "station": 119.22,
                        "low_chord": 0,
                        "high_chord": 657.1
                    },
                    {
                        "degree": -4.332313983194425,
                        "station": 119.88,
                        "low_chord": 0,
                        "high_chord": 657.05
                    },
                    {
                        "degree": -5.906141113765183,
                        "station": 120.46,
                        "low_chord": 0,
                        "high_chord": 656.99
                    },
                    {
                        "degree": -2.602562202497288,
                        "station": 120.68,
                        "low_chord": 0,
                        "high_chord": 656.98
                    },
                    {
                        "degree": -7.8533133019713794,
                        "station": 120.97,
                        "low_chord": 0,
                        "high_chord": 656.94
                    },
                    {
                        "degree": -3.1798301198793912,
                        "station": 121.33,
                        "low_chord": 0,
                        "high_chord": 656.92
                    },
                    {
                        "degree": -5.710593137494404,
                        "station": 121.73,
                        "low_chord": 0,
                        "high_chord": 656.88
                    },
                    {
                        "degree": -3.6522227803030316,
                        "station": 122.2,
                        "low_chord": 0,
                        "high_chord": 656.85
                    },
                    {
                        "degree": -6.340191745922073,
                        "station": 122.56,
                        "low_chord": 0,
                        "high_chord": 656.81
                    },
                    {
                        "degree": -3.2704879231806503,
                        "station": 122.91,
                        "low_chord": 0,
                        "high_chord": 656.79
                    },
                    {
                        "degree": -5.552971033031793,
                        "station": 123.63,
                        "low_chord": 0,
                        "high_chord": 656.72
                    },
                    {
                        "degree": -2.4895529219968515,
                        "station": 123.86,
                        "low_chord": 0,
                        "high_chord": 656.71
                    },
                    {
                        "degree": -5.411869152318916,
                        "station": 124.81,
                        "low_chord": 0,
                        "high_chord": 656.62
                    },
                    {
                        "degree": 0,
                        "station": 124.93,
                        "low_chord": 0,
                        "high_chord": 656.62
                    },
                    {
                        "degree": -4.853096386994132,
                        "station": 125.99,
                        "low_chord": 0,
                        "high_chord": 656.53
                    },
                    {
                        "degree": -3.3664606634267127,
                        "station": 126.67,
                        "low_chord": 0,
                        "high_chord": 656.49
                    },
                    {
                        "degree": -7.125016348895534,
                        "station": 126.83,
                        "low_chord": 0,
                        "high_chord": 656.47
                    },
                    {
                        "degree": -3.6619355755216305,
                        "station": 128.08,
                        "low_chord": 0,
                        "high_chord": 656.39
                    },
                    {
                        "degree": -4.635463426902848,
                        "station": 129.56,
                        "low_chord": 0,
                        "high_chord": 656.27
                    },
                    {
                        "degree": -3.2397002960991825,
                        "station": 130.09,
                        "low_chord": 0,
                        "high_chord": 656.24
                    },
                    {
                        "degree": -8.130102354149466,
                        "station": 130.23,
                        "low_chord": 0,
                        "high_chord": 656.22
                    },
                    {
                        "degree": -2.602562202497456,
                        "station": 130.67,
                        "low_chord": 0,
                        "high_chord": 656.2
                    },
                    {
                        "degree": -4.159642293714677,
                        "station": 131.77,
                        "low_chord": 0,
                        "high_chord": 656.12
                    },
                    {
                        "degree": -2.9356734464185035,
                        "station": 132.55,
                        "low_chord": 0,
                        "high_chord": 656.08
                    },
                    {
                        "degree": -5.355825042870639,
                        "station": 132.87,
                        "low_chord": 0,
                        "high_chord": 656.05
                    },
                    {
                        "degree": -2.2906100426364486,
                        "station": 133.37,
                        "low_chord": 0,
                        "high_chord": 656.03
                    },
                    {
                        "degree": -4.635463426898387,
                        "station": 134.11,
                        "low_chord": 0,
                        "high_chord": 655.97
                    },
                    {
                        "degree": -3.2154839917526368,
                        "station": 135,
                        "low_chord": 645,
                        "high_chord": 655.92
                    },
                    {
                        "degree": -2.779166864069554,
                        "station": 136.03,
                        "low_chord": 0,
                        "high_chord": 655.87
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 136.03,
                        "low_chord": 0,
                        "high_chord": 655.86
                    },
                    {
                        "degree": -3.1108406534950497,
                        "station": 136.95,
                        "low_chord": 0,
                        "high_chord": 655.81
                    },
                    {
                        "degree": -1.9091524329945688,
                        "station": 137.55,
                        "low_chord": 0,
                        "high_chord": 655.79
                    },
                    {
                        "degree": -3.0821808245253868,
                        "station": 138.85,
                        "low_chord": 0,
                        "high_chord": 655.72
                    },
                    {
                        "degree": -3.9724959407560676,
                        "station": 139.57,
                        "low_chord": 0,
                        "high_chord": 655.67
                    },
                    {
                        "degree": -1.5074357587736156,
                        "station": 139.95,
                        "low_chord": 0,
                        "high_chord": 655.66
                    },
                    {
                        "degree": -5.194428907730135,
                        "station": 140.17,
                        "low_chord": 0,
                        "high_chord": 655.64
                    },
                    {
                        "degree": -1.2453642667671936,
                        "station": 140.63,
                        "low_chord": 0,
                        "high_chord": 655.63
                    },
                    {
                        "degree": -3.9909130984260988,
                        "station": 141.06,
                        "low_chord": 0,
                        "high_chord": 655.6
                    },
                    {
                        "degree": 0,
                        "station": 141.25,
                        "low_chord": 0,
                        "high_chord": 655.6
                    },
                    {
                        "degree": -3.576334374994183,
                        "station": 141.73,
                        "low_chord": 0,
                        "high_chord": 655.57
                    },
                    {
                        "degree": 0,
                        "station": 141.92,
                        "low_chord": 0,
                        "high_chord": 655.57
                    },
                    {
                        "degree": -6.082336693284414,
                        "station": 144.36,
                        "low_chord": 0,
                        "high_chord": 655.31
                    },
                    {
                        "degree": -5.789008845170106,
                        "station": 146.53,
                        "low_chord": 0,
                        "high_chord": 655.09
                    },
                    {
                        "degree": -3.278986258854849,
                        "station": 148.45,
                        "low_chord": 0,
                        "high_chord": 654.98
                    },
                    {
                        "degree": -3.9698993572197643,
                        "station": 150.28,
                        "low_chord": 0,
                        "high_chord": 654.853
                    },
                    {
                        "degree": 0,
                        "station": 158.48,
                        "low_chord": 0,
                        "high_chord": 654.853
                    },
                    {
                        "degree": 89.86453322437659,
                        "station": 158.49,
                        "low_chord": 0,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": 0,
                        "station": 166.49,
                        "low_chord": 651.02,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": 0,
                        "station": 200.49,
                        "low_chord": 651.02,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": 0,
                        "station": 208.49,
                        "low_chord": 0,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": -89.86453322437697,
                        "station": 208.5,
                        "low_chord": 0,
                        "high_chord": 654.853
                    },
                    {
                        "degree": 0,
                        "station": 217.75,
                        "low_chord": 0,
                        "high_chord": 654.853
                    },
                    {
                        "degree": 2.55274638997268,
                        "station": 220.15,
                        "low_chord": 0,
                        "high_chord": 654.96
                    },
                    {
                        "degree": 1.0416266760090325,
                        "station": 223.45,
                        "low_chord": 0,
                        "high_chord": 655.02
                    },
                    {
                        "degree": 2.1678902792211785,
                        "station": 226.62,
                        "low_chord": 0,
                        "high_chord": 655.14
                    },
                    {
                        "degree": 3.503531644784458,
                        "station": 238.87,
                        "low_chord": 0,
                        "high_chord": 655.89
                    },
                    {
                        "degree": 2.4895529220025354,
                        "station": 240.02,
                        "low_chord": 0,
                        "high_chord": 655.94
                    },
                    {
                        "degree": 3.52145337691909,
                        "station": 241.32,
                        "low_chord": 0,
                        "high_chord": 656.02
                    },
                    {
                        "degree": 2.544804379810768,
                        "station": 242.22,
                        "low_chord": 0,
                        "high_chord": 656.06
                    },
                    {
                        "degree": 3.742988295689825,
                        "station": 243.29,
                        "low_chord": 0,
                        "high_chord": 656.13
                    },
                    {
                        "degree": 2.161079488224403,
                        "station": 243.82,
                        "low_chord": 0,
                        "high_chord": 656.15
                    },
                    {
                        "degree": 3.7640348649107422,
                        "station": 244.58,
                        "low_chord": 0,
                        "high_chord": 656.2
                    },
                    {
                        "degree": 2.3215305898306706,
                        "station": 245.32,
                        "low_chord": 0,
                        "high_chord": 656.23
                    },
                    {
                        "degree": 6.340191745903952,
                        "station": 245.5,
                        "low_chord": 0,
                        "high_chord": 656.25
                    },
                    {
                        "degree": 3.6522227803076324,
                        "station": 246.91,
                        "low_chord": 0,
                        "high_chord": 656.34
                    },
                    {
                        "degree": 3.468229258914019,
                        "station": 248.23,
                        "low_chord": 0,
                        "high_chord": 656.42
                    },
                    {
                        "degree": 2.3373058591349243,
                        "station": 248.72,
                        "low_chord": 0,
                        "high_chord": 656.44
                    },
                    {
                        "degree": 3.5214533769190126,
                        "station": 249.37,
                        "low_chord": 0,
                        "high_chord": 656.48
                    },
                    {
                        "degree": 4.7636416907219665,
                        "station": 249.85,
                        "low_chord": 0,
                        "high_chord": 656.52
                    },
                    {
                        "degree": 2.602562202497456,
                        "station": 250.29,
                        "low_chord": 0,
                        "high_chord": 656.54
                    },
                    {
                        "degree": 4.52882423693476,
                        "station": 251.3,
                        "low_chord": 0,
                        "high_chord": 656.62
                    },
                    {
                        "degree": 0,
                        "station": 251.43,
                        "low_chord": 0,
                        "high_chord": 656.62
                    },
                    {
                        "degree": 4.685899839498573,
                        "station": 252.04,
                        "low_chord": 0,
                        "high_chord": 656.67
                    },
                    {
                        "degree": 2.1210963966594463,
                        "station": 252.31,
                        "low_chord": 0,
                        "high_chord": 656.68
                    },
                    {
                        "degree": 4.497151614671041,
                        "station": 253.2,
                        "low_chord": 0,
                        "high_chord": 656.75
                    },
                    {
                        "degree": 3.012787504180491,
                        "station": 253.77,
                        "low_chord": 0,
                        "high_chord": 656.78
                    },
                    {
                        "degree": 5.013113755042672,
                        "station": 254.34,
                        "low_chord": 0,
                        "high_chord": 656.83
                    },
                    {
                        "degree": 3.4064437549916144,
                        "station": 255.18,
                        "low_chord": 0,
                        "high_chord": 656.88
                    },
                    {
                        "degree": 5.710593137494806,
                        "station": 255.48,
                        "low_chord": 0,
                        "high_chord": 656.91
                    },
                    {
                        "degree": 3.91824886407276,
                        "station": 256.21,
                        "low_chord": 0,
                        "high_chord": 656.96
                    },
                    {
                        "degree": 5.355825042850145,
                        "station": 257.17,
                        "low_chord": 0,
                        "high_chord": 657.05
                    },
                    {
                        "degree": 3.6913859864583634,
                        "station": 257.79,
                        "low_chord": 0,
                        "high_chord": 657.09
                    },
                    {
                        "degree": 4.208984924169202,
                        "station": 260.1,
                        "low_chord": 0,
                        "high_chord": 657.26
                    },
                    {
                        "degree": 5.572197803966675,
                        "station": 260.92,
                        "low_chord": 0,
                        "high_chord": 657.34
                    },
                    {
                        "degree": 0,
                        "station": 261.03,
                        "low_chord": 0,
                        "high_chord": 657.34
                    },
                    {
                        "degree": 5.411869152311878,
                        "station": 261.98,
                        "low_chord": 0,
                        "high_chord": 657.43
                    },
                    {
                        "degree": 4.763641690732917,
                        "station": 262.58,
                        "low_chord": 0,
                        "high_chord": 657.48
                    },
                    {
                        "degree": 2.489552921996698,
                        "station": 262.81,
                        "low_chord": 0,
                        "high_chord": 657.49
                    },
                    {
                        "degree": 6.170175095023966,
                        "station": 263.18,
                        "low_chord": 0,
                        "high_chord": 657.53
                    },
                    {
                        "degree": 2.489552921996698,
                        "station": 263.41,
                        "low_chord": 0,
                        "high_chord": 657.54
                    },
                    {
                        "degree": 5.826342029564232,
                        "station": 263.9,
                        "low_chord": 0,
                        "high_chord": 657.59
                    },
                    {
                        "degree": 4.028263666481284,
                        "station": 264.61,
                        "low_chord": 0,
                        "high_chord": 657.64
                    },
                    {
                        "degree": 5.630682757639419,
                        "station": 265.32,
                        "low_chord": 0,
                        "high_chord": 657.71
                    },
                    {
                        "degree": 4.316027519861475,
                        "station": 265.85,
                        "low_chord": 0,
                        "high_chord": 657.75
                    },
                    {
                        "degree": 5.869600443015467,
                        "station": 266.92,
                        "low_chord": 0,
                        "high_chord": 657.86
                    },
                    {
                        "degree": 0,
                        "station": 267.02,
                        "low_chord": 0,
                        "high_chord": 657.86
                    },
                    {
                        "degree": 5.659481840163108,
                        "station": 268.13,
                        "low_chord": 0,
                        "high_chord": 657.97
                    },
                    {
                        "degree": 0,
                        "station": 268.23,
                        "low_chord": 0,
                        "high_chord": 657.97
                    },
                    {
                        "degree": 5.710593137494575,
                        "station": 268.93,
                        "low_chord": 0,
                        "high_chord": 658.04
                    },
                    {
                        "degree": 4.807953963032195,
                        "station": 270,
                        "low_chord": 0,
                        "high_chord": 658.13
                    },
                    {
                        "degree": 5.3893117599688125,
                        "station": 270.53,
                        "low_chord": 0,
                        "high_chord": 658.18
                    },
                    {
                        "degree": 8.530765609970429,
                        "station": 270.73,
                        "low_chord": 0,
                        "high_chord": 658.21
                    },
                    {
                        "degree": 4.9392155421217145,
                        "station": 271.54,
                        "low_chord": 0,
                        "high_chord": 658.28
                    },
                    {
                        "degree": 5.663706258020876,
                        "station": 272.75,
                        "low_chord": 0,
                        "high_chord": 658.4
                    },
                    {
                        "degree": 0,
                        "station": 272.85,
                        "low_chord": 0,
                        "high_chord": 658.4
                    },
                    {
                        "degree": 6.225829064432365,
                        "station": 273.4,
                        "low_chord": 0,
                        "high_chord": 658.46
                    },
                    {
                        "degree": 0,
                        "station": 273.51,
                        "low_chord": 0,
                        "high_chord": 658.46
                    },
                    {
                        "degree": 5.241819946974664,
                        "station": 274.6,
                        "low_chord": 0,
                        "high_chord": 658.56
                    },
                    {
                        "degree": 6.225829064432365,
                        "station": 275.15,
                        "low_chord": 0,
                        "high_chord": 658.62
                    },
                    {
                        "degree": 0,
                        "station": 275.25,
                        "low_chord": 0,
                        "high_chord": 658.62
                    },
                    {
                        "degree": 6.2419143474196055,
                        "station": 275.89,
                        "low_chord": 0,
                        "high_chord": 658.69
                    },
                    {
                        "degree": 0,
                        "station": 275.98,
                        "low_chord": 0,
                        "high_chord": 658.69
                    },
                    {
                        "degree": 5.81562652948607,
                        "station": 277.06,
                        "low_chord": 0,
                        "high_chord": 658.8
                    },
                    {
                        "degree": 0,
                        "station": 277.17,
                        "low_chord": 0,
                        "high_chord": 658.8
                    },
                    {
                        "degree": 6.115503566291363,
                        "station": 277.73,
                        "low_chord": 0,
                        "high_chord": 658.86
                    },
                    {
                        "degree": 4.7636416907220065,
                        "station": 278.57,
                        "low_chord": 0,
                        "high_chord": 658.93
                    },
                    {
                        "degree": 45.00000000032569,
                        "station": 278.58,
                        "low_chord": 0,
                        "high_chord": 658.94
                    },
                    {
                        "degree": 4.763641690721685,
                        "station": 279.3,
                        "low_chord": 0,
                        "high_chord": 659
                    },
                    {
                        "degree": 6.340191745913384,
                        "station": 280.02,
                        "low_chord": 0,
                        "high_chord": 659.08
                    },
                    {
                        "degree": 2.862405226108499,
                        "station": 280.22,
                        "low_chord": 0,
                        "high_chord": 659.09
                    },
                    {
                        "degree": 6.241914347409548,
                        "station": 280.86,
                        "low_chord": 0,
                        "high_chord": 659.16
                    },
                    {
                        "degree": 0,
                        "station": 280.96,
                        "low_chord": 0,
                        "high_chord": 659.16
                    },
                    {
                        "degree": 5.710593137500228,
                        "station": 282.06,
                        "low_chord": 0,
                        "high_chord": 659.27
                    },
                    {
                        "degree": 3.9909130984260988,
                        "station": 282.49,
                        "low_chord": 0,
                        "high_chord": 659.3
                    },
                    {
                        "degree": 5.744158323769616,
                        "station": 284.18,
                        "low_chord": 0,
                        "high_chord": 659.47
                    },
                    {
                        "degree": 0,
                        "station": 284.27,
                        "low_chord": 0,
                        "high_chord": 659.47
                    },
                    {
                        "degree": 6.340191745904235,
                        "station": 284.9,
                        "low_chord": 0,
                        "high_chord": 659.54
                    },
                    {
                        "degree": 0,
                        "station": 285,
                        "low_chord": 0,
                        "high_chord": 659.54
                    },
                    {
                        "degree": 5.710593137500228,
                        "station": 286.1,
                        "low_chord": 0,
                        "high_chord": 659.65
                    },
                    {
                        "degree": 0,
                        "station": 286.2,
                        "low_chord": 0,
                        "high_chord": 659.65
                    },
                    {
                        "degree": 5.5275401516580756,
                        "station": 287.13,
                        "low_chord": 0,
                        "high_chord": 659.74
                    },
                    {
                        "degree": 6.254032743919487,
                        "station": 287.86,
                        "low_chord": 0,
                        "high_chord": 659.82
                    },
                    {
                        "degree": 3.731396999157228,
                        "station": 288.32,
                        "low_chord": 0,
                        "high_chord": 659.85
                    },
                    {
                        "degree": 6.203447901686511,
                        "station": 288.78,
                        "low_chord": 0,
                        "high_chord": 659.9
                    },
                    {
                        "degree": 4.763641690727076,
                        "station": 289.98,
                        "low_chord": 0,
                        "high_chord": 660
                    },
                    {
                        "degree": 6.225829064420661,
                        "station": 290.53,
                        "low_chord": 0,
                        "high_chord": 660.06
                    },
                    {
                        "degree": 4.653351587271623,
                        "station": 291.39,
                        "low_chord": 0,
                        "high_chord": 660.13
                    },
                    {
                        "degree": 6.458816378724609,
                        "station": 291.92,
                        "low_chord": 0,
                        "high_chord": 660.19
                    },
                    {
                        "degree": 0,
                        "station": 292.03,
                        "low_chord": 0,
                        "high_chord": 660.19
                    },
                    {
                        "degree": 5.710593137498951,
                        "station": 293.43,
                        "low_chord": 0,
                        "high_chord": 660.33
                    },
                    {
                        "degree": 4.085616779971019,
                        "station": 293.85,
                        "low_chord": 0,
                        "high_chord": 660.36
                    },
                    {
                        "degree": 6.241914347409548,
                        "station": 294.49,
                        "low_chord": 0,
                        "high_chord": 660.43
                    },
                    {
                        "degree": 5.247138901618187,
                        "station": 295.47,
                        "low_chord": 0,
                        "high_chord": 660.52
                    },
                    {
                        "degree": 0,
                        "station": 295.58,
                        "low_chord": 0,
                        "high_chord": 660.52
                    },
                    {
                        "degree": 6.009005957497648,
                        "station": 296.34,
                        "low_chord": 0,
                        "high_chord": 660.6
                    },
                    {
                        "degree": 4.467159061384926,
                        "station": 296.98,
                        "low_chord": 0,
                        "high_chord": 660.65
                    },
                    {
                        "degree": 5.906141113772544,
                        "station": 297.85,
                        "low_chord": 0,
                        "high_chord": 660.74
                    },
                    {
                        "degree": 0,
                        "station": 297.95,
                        "low_chord": 0,
                        "high_chord": 660.74
                    },
                    {
                        "degree": 5.856013585431712,
                        "station": 298.73,
                        "low_chord": 0,
                        "high_chord": 660.82
                    },
                    {
                        "degree": 2.6025622024977917,
                        "station": 298.95,
                        "low_chord": 0,
                        "high_chord": 660.83
                    },
                    {
                        "degree": 5.6774166620438535,
                        "station": 300.66,
                        "low_chord": 0,
                        "high_chord": 661
                    },
                    {
                        "degree": 4.289153328815375,
                        "station": 301.46,
                        "low_chord": 0,
                        "high_chord": 661.06
                    },
                    {
                        "degree": 7.594643368605667,
                        "station": 301.76,
                        "low_chord": 0,
                        "high_chord": 661.1
                    },
                    {
                        "degree": 4.3323139831844255,
                        "station": 302.42,
                        "low_chord": 0,
                        "high_chord": 661.15
                    },
                    {
                        "degree": 6.2540327439199705,
                        "station": 303.15,
                        "low_chord": 0,
                        "high_chord": 661.23
                    },
                    {
                        "degree": 4.635463426898387,
                        "station": 303.89,
                        "low_chord": 0,
                        "high_chord": 661.29
                    },
                    {
                        "degree": 5.78239232236683,
                        "station": 304.68,
                        "low_chord": 0,
                        "high_chord": 661.37
                    },
                    {
                        "degree": 0,
                        "station": 304.78,
                        "low_chord": 0,
                        "high_chord": 661.37
                    },
                    {
                        "degree": 6.009005957497203,
                        "station": 305.54,
                        "low_chord": 0,
                        "high_chord": 661.45
                    },
                    {
                        "degree": 4.763641690721911,
                        "station": 306.74,
                        "low_chord": 0,
                        "high_chord": 661.55
                    },
                    {
                        "degree": 6.044092162243472,
                        "station": 307.59,
                        "low_chord": 0,
                        "high_chord": 661.64
                    },
                    {
                        "degree": 3.9004937423783734,
                        "station": 308.03,
                        "low_chord": 0,
                        "high_chord": 661.67
                    },
                    {
                        "degree": 6.170175095032666,
                        "station": 308.77,
                        "low_chord": 0,
                        "high_chord": 661.75
                    },
                    {
                        "degree": 3.576334374994183,
                        "station": 309.09,
                        "low_chord": 0,
                        "high_chord": 661.77
                    },
                    {
                        "degree": 5.267697128043955,
                        "station": 310.5,
                        "low_chord": 0,
                        "high_chord": 661.9
                    },
                    {
                        "degree": 5.710593137503788,
                        "station": 311.2,
                        "low_chord": 0,
                        "high_chord": 661.97
                    },
                    {
                        "degree": 4.085616779971019,
                        "station": 311.62,
                        "low_chord": 0,
                        "high_chord": 662
                    },
                    {
                        "degree": 6.170175095032666,
                        "station": 312.36,
                        "low_chord": 0,
                        "high_chord": 662.08
                    },
                    {
                        "degree": 0,
                        "station": 312.47,
                        "low_chord": 0,
                        "high_chord": 662.08
                    },
                    {
                        "degree": 6.072456407202234,
                        "station": 313.41,
                        "low_chord": 0,
                        "high_chord": 662.18
                    },
                    {
                        "degree": 0,
                        "station": 313.51,
                        "low_chord": 0,
                        "high_chord": 662.18
                    },
                    {
                        "degree": 5.617580590132205,
                        "station": 314.12,
                        "low_chord": 0,
                        "high_chord": 662.24
                    },
                    {
                        "degree": 0,
                        "station": 314.23,
                        "low_chord": 0,
                        "high_chord": 662.24
                    },
                    {
                        "degree": 6.225829064420661,
                        "station": 314.78,
                        "low_chord": 0,
                        "high_chord": 662.3
                    },
                    {
                        "degree": 2.2906100426364486,
                        "station": 315.03,
                        "low_chord": 0,
                        "high_chord": 662.31
                    },
                    {
                        "degree": 5.710593137504356,
                        "station": 316.33,
                        "low_chord": 0,
                        "high_chord": 662.44
                    },
                    {
                        "degree": 4.455602833322057,
                        "station": 317.1,
                        "low_chord": 0,
                        "high_chord": 662.5
                    },
                    {
                        "degree": 5.5054778579812504,
                        "station": 317.93,
                        "low_chord": 0,
                        "high_chord": 662.58
                    },
                    {
                        "degree": 0,
                        "station": 318.03,
                        "low_chord": 0,
                        "high_chord": 662.58
                    },
                    {
                        "degree": 5.87739260663777,
                        "station": 318.71,
                        "low_chord": 0,
                        "high_chord": 662.65
                    },
                    {
                        "degree": 2.6025622024971202,
                        "station": 318.93,
                        "low_chord": 0,
                        "high_chord": 662.66
                    },
                    {
                        "degree": 5.640549432159673,
                        "station": 319.74,
                        "low_chord": 0,
                        "high_chord": 662.74
                    },
                    {
                        "degree": 4.08561677997124,
                        "station": 320.44,
                        "low_chord": 0,
                        "high_chord": 662.79
                    },
                    {
                        "degree": 5.142764557886051,
                        "station": 321.44,
                        "low_chord": 0,
                        "high_chord": 662.88
                    },
                    {
                        "degree": 3.3664606634268064,
                        "station": 321.95,
                        "low_chord": 0,
                        "high_chord": 662.91
                    },
                    {
                        "degree": 4.763641690732467,
                        "station": 322.55,
                        "low_chord": 0,
                        "high_chord": 662.96
                    },
                    {
                        "degree": 5.477368728824215,
                        "station": 323.28,
                        "low_chord": 0,
                        "high_chord": 663.03
                    },
                    {
                        "degree": 3.87852450285497,
                        "station": 323.87,
                        "low_chord": 0,
                        "high_chord": 663.07
                    },
                    {
                        "degree": 5.35582504285046,
                        "station": 324.83,
                        "low_chord": 0,
                        "high_chord": 663.16
                    },
                    {
                        "degree": 3.7826454465981185,
                        "station": 326.04,
                        "low_chord": 0,
                        "high_chord": 663.24
                    },
                    {
                        "degree": 5.194428907730135,
                        "station": 326.48,
                        "low_chord": 0,
                        "high_chord": 663.28
                    },
                    {
                        "degree": 3.5763343750024204,
                        "station": 327.28,
                        "low_chord": 0,
                        "high_chord": 663.33
                    },
                    {
                        "degree": 6.340191745903289,
                        "station": 327.55,
                        "low_chord": 0,
                        "high_chord": 663.36
                    },
                    {
                        "degree": 3.5214533769191663,
                        "station": 328.2,
                        "low_chord": 0,
                        "high_chord": 663.4
                    },
                    {
                        "degree": 6.170175095041366,
                        "station": 328.57,
                        "low_chord": 0,
                        "high_chord": 663.44
                    },
                    {
                        "degree": 4.159642293708787,
                        "station": 329.12,
                        "low_chord": 0,
                        "high_chord": 663.48
                    },
                    {
                        "degree": 2.045408488885568,
                        "station": 329.4,
                        "low_chord": 0,
                        "high_chord": 663.49
                    },
                    {
                        "degree": 6.340191745903289,
                        "station": 329.67,
                        "low_chord": 0,
                        "high_chord": 663.52
                    },
                    {
                        "degree": 2.792702365710964,
                        "station": 330.08,
                        "low_chord": 0,
                        "high_chord": 663.54
                    },
                    {
                        "degree": 4.8990924537926475,
                        "station": 330.78,
                        "low_chord": 0,
                        "high_chord": 663.6
                    },
                    {
                        "degree": 3.442215285894148,
                        "station": 332.11,
                        "low_chord": 0,
                        "high_chord": 663.68
                    },
                    {
                        "degree": 5.355825042870639,
                        "station": 332.43,
                        "low_chord": 0,
                        "high_chord": 663.71
                    },
                    {
                        "degree": 3.778197707158153,
                        "station": 333.49,
                        "low_chord": 0,
                        "high_chord": 663.78
                    },
                    {
                        "degree": 0,
                        "station": 333.63,
                        "low_chord": 0,
                        "high_chord": 663.78
                    },
                    {
                        "degree": 4.053554231832894,
                        "station": 334.9,
                        "low_chord": 0,
                        "high_chord": 663.87
                    },
                    {
                        "degree": 1.9091524329945688,
                        "station": 335.2,
                        "low_chord": 0,
                        "high_chord": 663.88
                    },
                    {
                        "degree": 4.467159061385321,
                        "station": 335.84,
                        "low_chord": 0,
                        "high_chord": 663.93
                    },
                    {
                        "degree": 0,
                        "station": 335.98,
                        "low_chord": 0,
                        "high_chord": 663.93
                    },
                    {
                        "degree": 3.887909560835944,
                        "station": 337.01,
                        "low_chord": 0,
                        "high_chord": 664
                    },
                    {
                        "degree": 2.7702157971976566,
                        "station": 337.63,
                        "low_chord": 0,
                        "high_chord": 664.03
                    },
                    {
                        "degree": 4.332313983194239,
                        "station": 338.29,
                        "low_chord": 0,
                        "high_chord": 664.08
                    },
                    {
                        "degree": 1.7357045889268947,
                        "station": 338.62,
                        "low_chord": 0,
                        "high_chord": 664.09
                    },
                    {
                        "degree": 4.08561677997124,
                        "station": 339.32,
                        "low_chord": 0,
                        "high_chord": 664.14
                    },
                    {
                        "degree": 3.416588191768163,
                        "station": 339.99,
                        "low_chord": 0,
                        "high_chord": 664.18
                    },
                    {
                        "degree": 2.3215305898393694,
                        "station": 340.73,
                        "low_chord": 0,
                        "high_chord": 664.21
                    },
                    {
                        "degree": 3.1363583683299066,
                        "station": 341.46,
                        "low_chord": 0,
                        "high_chord": 664.25
                    },
                    {
                        "degree": 18.434948822889446,
                        "station": 341.49,
                        "low_chord": 0,
                        "high_chord": 664.26
                    },
                    {
                        "degree": 2.58302066863763,
                        "station": 342.82,
                        "low_chord": 0,
                        "high_chord": 664.32
                    },
                    {
                        "degree": 4.0141756954074355,
                        "station": 343.39,
                        "low_chord": 0,
                        "high_chord": 664.36
                    },
                    {
                        "degree": 2.1610794882242876,
                        "station": 343.92,
                        "low_chord": 0,
                        "high_chord": 664.38
                    },
                    {
                        "degree": 3.632950739490086,
                        "station": 345.18,
                        "low_chord": 0,
                        "high_chord": 664.46
                    },
                    {
                        "degree": 1.7357045889268947,
                        "station": 345.84,
                        "low_chord": 0,
                        "high_chord": 664.48
                    },
                    {
                        "degree": 3.4336303624474067,
                        "station": 346.34,
                        "low_chord": 0,
                        "high_chord": 664.51
                    },
                    {
                        "degree": 2.0638197284550612,
                        "station": 347.45,
                        "low_chord": 0,
                        "high_chord": 664.55
                    },
                    {
                        "degree": 5.194428907758833,
                        "station": 347.67,
                        "low_chord": 0,
                        "high_chord": 664.57
                    },
                    {
                        "degree": 1.3639275316018116,
                        "station": 348.09,
                        "low_chord": 0,
                        "high_chord": 664.58
                    },
                    {
                        "degree": 3.9909130984260988,
                        "station": 348.52,
                        "low_chord": 0,
                        "high_chord": 664.61
                    },
                    {
                        "degree": 1.4320961841632225,
                        "station": 348.92,
                        "low_chord": 0,
                        "high_chord": 664.62
                    },
                    {
                        "degree": 3.632950739484937,
                        "station": 349.55,
                        "low_chord": 0,
                        "high_chord": 664.66
                    },
                    {
                        "degree": 0,
                        "station": 349.75,
                        "low_chord": 0,
                        "high_chord": 664.66
                    },
                    {
                        "degree": 3.731396999171329,
                        "station": 350.21,
                        "low_chord": 0,
                        "high_chord": 664.69
                    },
                    {
                        "degree": 1.4688007143844337,
                        "station": 350.99,
                        "low_chord": 0,
                        "high_chord": 664.71
                    },
                    {
                        "degree": 2.4895529219969026,
                        "station": 352.37,
                        "low_chord": 0,
                        "high_chord": 664.77
                    },
                    {
                        "degree": 1.652304677649773,
                        "station": 353.41,
                        "low_chord": 0,
                        "high_chord": 664.8
                    },
                    {
                        "degree": 3.8140748343090887,
                        "station": 353.71,
                        "low_chord": 0,
                        "high_chord": 664.82
                    },
                    {
                        "degree": 2.161079488224403,
                        "station": 355.83,
                        "low_chord": 0,
                        "high_chord": 664.9
                    },
                    {
                        "degree": 0,
                        "station": 356.1,
                        "low_chord": 0,
                        "high_chord": 664.9
                    },
                    {
                        "degree": 2.4895529219969026,
                        "station": 356.79,
                        "low_chord": 0,
                        "high_chord": 664.93
                    },
                    {
                        "degree": 0,
                        "station": 357.09,
                        "low_chord": 0,
                        "high_chord": 664.93
                    },
                    {
                        "degree": 2.5637702114723178,
                        "station": 357.76,
                        "low_chord": 0,
                        "high_chord": 664.96
                    },
                    {
                        "degree": 1.7899106082444804,
                        "station": 358.4,
                        "low_chord": 0,
                        "high_chord": 664.98
                    },
                    {
                        "degree": 0.8814039965812901,
                        "station": 359.05,
                        "low_chord": 0,
                        "high_chord": 664.99
                    },
                    {
                        "degree": 3.2704879231809154,
                        "station": 359.4,
                        "low_chord": 0,
                        "high_chord": 665.01
                    },
                    {
                        "degree": 0,
                        "station": 359.7,
                        "low_chord": 0,
                        "high_chord": 665.01
                    },
                    {
                        "degree": 2.563770211462615,
                        "station": 360.37,
                        "low_chord": 0,
                        "high_chord": 665.04
                    },
                    {
                        "degree": 0,
                        "station": 360.75,
                        "low_chord": 0,
                        "high_chord": 665.04
                    },
                    {
                        "degree": 2.544804379810848,
                        "station": 361.2,
                        "low_chord": 0,
                        "high_chord": 665.06
                    },
                    {
                        "degree": 0.9877603996445041,
                        "station": 362.36,
                        "low_chord": 0,
                        "high_chord": 665.08
                    },
                    {
                        "degree": 2.602562202497456,
                        "station": 362.8,
                        "low_chord": 0,
                        "high_chord": 665.1
                    },
                    {
                        "degree": 0,
                        "station": 363.21,
                        "low_chord": 0,
                        "high_chord": 665.1
                    },
                    {
                        "degree": 2.602562202497456,
                        "station": 363.65,
                        "low_chord": 0,
                        "high_chord": 665.12
                    },
                    {
                        "degree": 0,
                        "station": 364.09,
                        "low_chord": 0,
                        "high_chord": 665.12
                    },
                    {
                        "degree": 2.021364940354125,
                        "station": 364.94,
                        "low_chord": 0,
                        "high_chord": 665.15
                    },
                    {
                        "degree": 1.1612419083129328,
                        "station": 366.42,
                        "low_chord": 0,
                        "high_chord": 665.18
                    },
                    {
                        "degree": 0,
                        "station": 366.97,
                        "low_chord": 0,
                        "high_chord": 665.18
                    },
                    {
                        "degree": 26.56505117733854,
                        "station": 366.99,
                        "low_chord": 0,
                        "high_chord": 665.19
                    },
                    {
                        "degree": 0,
                        "station": 367.54,
                        "low_chord": 0,
                        "high_chord": 665.19
                    },
                    {
                        "degree": 8.130102354149466,
                        "station": 367.61,
                        "low_chord": 0,
                        "high_chord": 665.2
                    },
                    {
                        "degree": 0,
                        "station": 368.17,
                        "low_chord": 0,
                        "high_chord": 665.2
                    },
                    {
                        "degree": 18.43494882292201,
                        "station": 368.2,
                        "low_chord": 0,
                        "high_chord": 665.21
                    },
                    {
                        "degree": 0,
                        "station": 368.81,
                        "low_chord": 0,
                        "high_chord": 665.21
                    },
                    {
                        "degree": 18.43494882292201,
                        "station": 368.84,
                        "low_chord": 0,
                        "high_chord": 665.22
                    },
                    {
                        "degree": 0.5787255656072304,
                        "station": 369.83,
                        "low_chord": 0,
                        "high_chord": 665.23
                    }
                ],
                "ulr": [
                    {
                        "degree": -0.5977412366096115,
                        "station": 149.49,
                        "low_chord": 0,
                        "high_chord": 654.853
                    },
                    {
                        "degree": 89.86453322437697,
                        "station": 149.5,
                        "low_chord": 0,
                        "high_chord": 659.0825
                    }
                ],
                "urr": [
                    {
                        "degree": 0,
                        "station": 199.5,
                        "low_chord": 0,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": -89.86453322437697,
                        "station": 199.51,
                        "low_chord": 0,
                        "high_chord": 654.853
                    }
                ],
                "dlr": [
                    {
                        "degree": -2.779166864069554,
                        "station": 136.03,
                        "low_chord": 0,
                        "high_chord": 655.87
                    },
                    {
                        "degree": 89.99999999427042,
                        "station": 136.03,
                        "low_chord": 0,
                        "high_chord": 655.86
                    }
                ],
                "drr": [
                    {
                        "degree": 0,
                        "station": 208.49,
                        "low_chord": 0,
                        "high_chord": 659.0825
                    },
                    {
                        "degree": -89.86453322437697,
                        "station": 208.5,
                        "low_chord": 0,
                        "high_chord": 654.853
                    }
                ],
                "ulr_high_elev": 654.853,
                "ulr_high_sta": 149.49,
                "ulr_top_rail": 659.0825,
                "urr_high_elev": 654.853,
                "urr_high_sta": 199.5,
                "urr_top_rail": 659.0825,
                "dlr_high_elev": 655.86,
                "dlr_high_sta": 136.03,
                "dlr_top_rail": 655.87,
                "drr_high_elev": 654.853,
                "drr_high_sta": 208.49,
                "drr_top_rail": 659.0825,
                "ulr_rail_height": "4.23",
                "urr_rail_height": "4.23",
                "dlr_rail_height": "0.01",
                "drr_rail_height": "4.23",
                "up_left_xs_station": 205.82,
                "up_left_xs_elevation": 654.87,
                "up_left_diff": "-48.32",
                "up_left_ratio": "-0.37",
                "down_dist": "18.87",
                "down_left_xs_station": 125.89,
                "down_left_xs_elevation": 654.86,
                "down_left_diff": "10.14",
                "down_left_ratio": "1.86",
                "up_dist_btw_xs": "64.67",
                "up_right_xs_station": 270.49,
                "up_right_xs_elevation": 654.87,
                "up_right_diff": "9.68",
                "up_right_ratio": "1.86",
                "down_dist_btw_xs": "26.78",
                "down_right_xs_station": 152.67,
                "down_right_xs_elevation": 654.86,
                "down_right_diff": "16.64",
                "down_right_ratio": "1.13",
                "up_left_calc": "1",
                "up_right_calc": "1",
                "down_left_calc": "1",
                "down_right_calc": "1",
                "around_structure_table": {},
                "skew": "-4",
                "up_left_ratio_skew": "-0.46",
                "up_right_ratio_skew": "2.24",
                "down_left_ratio_skew": "2.24",
                "down_right_ratio_skew": "0.97"
            }
        ]
    }
]